import { DeheadingReportingTypeEnum, EmployeeRolesEnum, ErrorResponse, FgStatusEnum, GlobalStatus, GlobalVariableValues, JobCompletedEnum, OperationTypeEnum, ProductCategoryEnum, ProductionProcessTypeEnum, SaleOrderIdRequest, TransactionType, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { CommonResponse, ContractorIdReq, ItemsDropDownDto, ItemsDropDownResponseModel, MasterInfoFromIndentResponse, PlantIdRequest, UnitTypeEnum } from "@gtpl/shared-models/masters";
import { AllProdInvResponseModel, GrnInfoReq, InventoryWipResponse, LotAndOperationReq, LotCodeDropDown, LotCodeDropDownResponse, LotNoInfo, LotNumberInfoResponse, LotNumberReportResponseModel, LotSos, LotTrackingResponse, OperationReportingReq, PackingInfoReq, ProdInvData, ProdInvResponseModel, ProductionInventoryDetails, ProductionInventoryResponse, subPlantHistoryReport, SubPlantResponseModel, TransportChargesReq, TreeStructureData,WipData, WipQuantityResponseModel ,JobReportingInfoReq} from "@gtpl/shared-models/production-management";
import { forwardRef, Inject, Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getConnection, getManager, QueryRunner, Raw, Repository } from "typeorm";
import { LotInfoRequest } from "./dto/lot-info.request";
// import { , eachDayOfInterval } from 'date-fns';
import { format, getDaysInMonth } from 'date-fns'; 
import { LotNumberRequest } from "./dto/lot-number.request";
import { ProdInvAdapter } from "./dto/prod-inv.adapter";
import { ProdInvDTO } from "./dto/prod-inv.dto";
import { ProductionInventory } from "./entities/production-inventory.entity";
import { ProductionInventoryRepository } from "./repositories/production-inventory.repository";
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { HLpercentagesService, SuppliersService, UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { ProductionLogService } from './production-log.service';
import { OperationSequenceRequest } from "./dto/operation-sequence.request";
import { VariantOperationsService } from "../variant-operations/variant-operations.service";
import { ProductionLogRepository } from "./repositories/production-log.repository";
import { subplantReportRequest } from "./dto/subplanthistory-request";
import { GrnInformationDto } from "./dto/grn-information.dto";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { ProductionLogData } from "./dto/production-log.dto";
import { ProductionLog } from "./entities/production-log.entity";
import { LotCodeOpsEntity } from "./entities/lot-code.entity";
import appSettings from 'apps/services/config';
import { LotCodeOpsRepository } from "./repositories/lot-code.repository";
import { ItemsDetails, ReportRequest, SaleOrderDropDownDto, SaleOrderDropDownResponseModel, SaleOrderItemsDropDownResponseModel } from "@gtpl/shared-models/sale-management";
import { UnitRequest } from "./dto/unit.id.request";
import { salordeIdandsoItemIdReq } from "./dto/so-and-soitem-request";
import { ProductionLogRequest } from "libs/shared-models/production-management/src/lib/production-inv/production-log.req";
import { unitRequiest } from "@gtpl/shared-models/warehouse-management";
import { LotCodeRequest } from "./dto/lot-code.request";
import { NonSoakedProductsEntity } from "./entities/non-soaked-products.entity";
import { ReweighmentReq } from "@gtpl/shared-models/raw-material-procurement";
import {GrnItems} from '../../../../raw-material-procurement/src/app/raw-material-grn/raw-material-grn-items.entity'
import { ProductionWorkersEntity } from "./entities/production-workers-info.entity";
import { NonSoakedProductsRepository } from "./repositories/non-soaking-products.repository";
import moment from "moment";

const util = require('util')


@Injectable()
export class ProductionInventoryService {
  constructor(
    @InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    @InjectRepository(NonSoakedProductsRepository)
    private nonSoakedProductsRepository : Repository<NonSoakedProductsRepository>,
    private prodInvAdapter: ProdInvAdapter,
    // private productAdapter: ProductAdapter,
    private saleOrderService: SaleOrderService,
    private variantOpService: VariantOperationsService,
    private supplierService: SuppliersService,
    private indentService: IndentService,
    private productionLogService: ProductionLogService,
    @InjectRepository(ProductionLogRepository)
    private logRepository: ProductionLogRepository,
    private saleService: SaleOrderService,
    private unitCodesService: UnitcodeService,
  ) { }

  async createGrnInventory(grnDto: GrnInformationDto): Promise<ProdInvResponseModel> {
    const manager = new GenericTransactionManager();
    try {
      // Create Production Inventory
      const grn = new ProductionInventory();
      grn.lotNumber = grnDto.lotNumber;
      grn.subLotNumber = grnDto.lotNumber;
      grn.saleOrderId = grnDto.saleOrderId;
      grn.saleOrderItemId = grnDto.saleOrderItemId;
      grn.operation = OperationTypeEnum.GRN;
      grn.nextOperation = OperationTypeEnum.BE_HEADING;
      grn.physicalQuantity = grnDto.quantity;
      grn.inputGrade = String(grnDto.count);
      grn.plantId = grnDto.plantId;
      grn.subPlantId = grnDto.subPlantId;
      grn.boxes = grnDto.boxes;
      grn.opBoxes = grnDto.boxes;
      grn.weighmentReq = GlobalStatus.NO;
      grn.status = FgStatusEnum.OPEN;
      grn.createdUser = grnDto.createdUser;
      // grn.plantLotNumber = grnDto.remarks;
      await manager.startTransaction();
      const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(grn);
      // job number generation 
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0;
      let toDate = 0;
      let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.GRN } })).length;


      if (CurrentMonth < 4) {
        fromDate = (CurrentYear-1);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);
      }

      totalRecords = totalRecords + 1;

      var refNo = totalRecords + "";
      while (refNo.length < 4) refNo = "0" + refNo;

      const grnJobNo = "GRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

      // Create Log
      const productionLogObj = new ProductionLog();
      productionLogObj.lotNumber = grnDto.lotNumber;
      productionLogObj.subLotNumber = grnDto.lotNumber;
      productionLogObj.saleOrderId = grnDto.saleOrderId;
      productionLogObj.saleOrderItemId = grnDto.saleOrderItemId;
      productionLogObj.operationType = OperationTypeEnum.GRN;
      productionLogObj.jobNumber = grnJobNo;
      productionLogObj.plantId = grnDto.plantId;
      // productionLogObj.plantLotNumber=grnDto.remarks;
      if (grnDto.subPlantId) {
        productionLogObj.subPlantId = grnDto.subPlantId;
        productionLogObj.workStationType = WorkStationTypeEnum.EXTERNAL;
      }
      productionLogObj.jobStatus = JobCompletedEnum.NO;
      productionLogObj.inputGrade = String(grnDto.count);
      productionLogObj.inputQuantity = grnDto.quantity;
      productionLogObj.inputBoxes = grnDto.boxes;
      productionLogObj.assignedUser = grnDto.createdUser;
      productionLogObj.createdUser = grnDto.createdUser;
      productionLogObj.prodInvId = prodInvResponse.productionInventoryId;
      const createLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);

      const lotCodeOps = new LotCodeOpsEntity();
      lotCodeOps.grnDate = grnDto.grnDate;
      lotCodeOps.indentId = grnDto.indentId;
      lotCodeOps.grnNumber = grnDto.grnNumber;
      lotCodeOps.lotNumber = grnDto.lotNumber;
      lotCodeOps.saleOrderId = grnDto.saleOrderId;
      lotCodeOps.saleOrderItemId = grnDto.saleOrderItemId;
      lotCodeOps.supplierType = grnDto.supplierType;
      lotCodeOps.farmer = grnDto.farmer;
      lotCodeOps.farmerCode = grnDto.farmerCode;
      lotCodeOps.quantity = grnDto.quantity;
      lotCodeOps.count = grnDto.count;
      lotCodeOps.price = grnDto.price;
      lotCodeOps.boxes = grnDto.boxes;
      lotCodeOps.plantId = grnDto.plantId;
      lotCodeOps.subPlantId = grnDto.subPlantId;
      lotCodeOps.isActive = true;
      lotCodeOps.createdUser = grnDto.createdUser;
      lotCodeOps.lotNumber = grnDto.lotNumber;

      const savedLotCodeOpsEntity: LotCodeOpsEntity = await manager.getCustomRepository(LotCodeOpsRepository).save(
        lotCodeOps
      );

      if (prodInvResponse && createLog && savedLotCodeOpsEntity) {
        await manager.completeTransaction();
        return new ProdInvResponseModel(true, 1111, 'Grn Information Updated to Production Successfully');
      } else {
        await manager.releaseTransaction();
        throw new ErrorResponse(9999, 'Failed To Update Production');
      }
    } catch (error) {
      await manager.releaseTransaction();
      return error;
    }
  }

  async getProdInvDetailsWithoutRelations(lotNumber: string): Promise<ProductionInventory> {
    // tslint:disable-next-line: typedef
    const prodInvResponse = await this.inventoryRepository.findOne({
      where: { lotNumber: Raw(alias => `lot_number = '${lotNumber}'`) },
    });
    if (prodInvResponse) {
      return prodInvResponse;
    } else {
      return null;
    }
  }


  async createProdInv(prodInvDto: ProdInvDTO, isUpdate: boolean): Promise<ProdInvResponseModel> {
    // console.log(statesDto);

    try {
      // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      if (!isUpdate) {
        const prodInvEntity = await this.getProdInvDetailsWithoutRelations(prodInvDto.lotNumber);
        if (prodInvEntity) {
          //return new InformationMessageError(11104, "State already exists");
          throw new ErrorResponse(11104, 'ProdInv already exists');
        }
      }
      else {
        const prodInvEntity = await this.getProdInvDetailsWithoutRelations(prodInvDto.lotNumber);
        if (prodInvEntity) {
          if (prodInvEntity.productionInventoryId != prodInvDto.productionInventoryId) {
            throw new ErrorResponse(11104, 'ProdInv already exists');
          }
        }
      }
      const convertedProdInvEntity: ProductionInventory = this.prodInvAdapter.convertDtoToEntity(prodInvDto, isUpdate);
      const savedProdInvEntity: ProductionInventory = await this.inventoryRepository.save(
        convertedProdInvEntity
      );
      const savedProdInvDto: ProdInvDTO = this.prodInvAdapter.convertEntityToDto(convertedProdInvEntity);
      // console.log(savedStateDto);
      if (savedProdInvDto) {
        // generating resposnse
        const response = new ProdInvResponseModel(true, 1, isUpdate ? 'ProdInv Updated Successfully' : 'ProdInv Created Successfully');
        return response
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'ProdInv saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      return error;
    }
  }

  async getAllProdInvs(): Promise<AllProdInvResponseModel> {
    // const page: number = 1;
    try {
      const prodInvDtos: ProdInvData[] = [];

      const prodInvEntities = await this.inventoryRepository.createQueryBuilder('production_inventory')
        .where('physical_quantity+intransit_quantity-issued_quantity>0').getMany();

      if (prodInvEntities.length === 0) {
        throw new ErrorResponse(10000, 'No Records Found');
      }
      for (const grn of prodInvEntities) {
        const soInfo = await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: grn.saleOrderId })
        const soREq: saleOrder = {
          saleOrderId: grn.saleOrderId
        }
        const soItemInfo = await this.saleOrderService.getSaleOrderItemsForSo(soREq);
        prodInvDtos.push(new ProdInvData(grn.productionInventoryId, grn.lotNumber, grn.saleOrderId, grn.saleOrderItemId, grn.physicalQuantity, grn.issuedQuantity, grn.intransitQuantity, grn.wastageQuantity, grn.wipQuantity, grn.rejectedQuantity, Number(grn.inputGrade), grn.boxes, grn.plantId, soInfo.saleOrderNumber, soItemInfo.data.itemsDetails[0].item, grn.subPlantId, grn.weighmentReq, grn.operation, grn.nextOperation, grn.status, grn.createdUser))
      }
      return new AllProdInvResponseModel(true, 1, 'Production inventories retrieved successfully', prodInvDtos);
    } catch (err) {
      return err;
    }
  }
  async getLotNumbers(req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.inventoryRepository.getLotNumbers(req);
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }
  
  async getLotNumberInfo(lotNoReq: LotInfoRequest): Promise<LotNumberInfoResponse> {
    try {
      // const lotNoInformation = await this.inventoryRepository.findOne({select:['lotNumber','issuedQuantity','saleOrderId','saleOrderItemId','inputGrade','boxes', 'physicalQuantity'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId, nextOperation:lotNoReq.presentOperation}});
      const lotNoInformation = await this.inventoryRepository.getLotNumberInfo(lotNoReq);

      if (lotNoInformation) {
        let availBoxes = lotNoInformation[0].boxes;
        let boxWeight = lotNoInformation[0].physicalQuantity / lotNoInformation[0].boxes;
        if (lotNoReq.presentOperation == OperationTypeEnum.BE_HEADING || lotNoReq.presentOperation == OperationTypeEnum.GRADING || lotNoReq.presentOperation == OperationTypeEnum.VALUE_ADDITION) {
       


          availBoxes = (lotNoInformation[0].opBoxes-lotNoInformation[0].transferredBoxes);

          const getReportedQty = await this.productionLogService.getOperationQuantity(lotNoReq.lotNumber, lotNoReq.plantId, lotNoReq.presentOperation);
          if (getReportedQty) {
            // availQty = Number(availQty) - Number(getReportedQty.quantity)
            availBoxes = Number(availBoxes) - Number(getReportedQty.boxes);
          }
          boxWeight = (lotNoInformation[0].availableQuantity) / (availBoxes);
        }

        const soInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: lotNoInformation[0].saleOrderItemId })

        const lotInfo = new LotNoInfo(lotNoInformation[0].lotNumber, lotNoInformation[0].saleOrderId, soInfo.data.poNumber, lotNoInformation[0].saleOrderItemId, '', lotNoInformation[0].inputGrade, lotNoInformation[0].availableQuantity, availBoxes, lotNoInformation[0].prodInvId, lotNoInformation[0].inputGrade, lotNoInformation[0].outputGrade, boxWeight, soInfo.data.soakingTime, soInfo.data.soakingStyle, lotNoInformation[0].opBoxes,lotNoInformation[0].lot,lotNoInformation[0].mainPlantId,soInfo.data.poNumber);
        return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
      } else {
        throw new ErrorResponse(9999, 'Unable to get lot info')
      }
    } catch (error) {
      return error;
    }
  }


  async getLotNumberInfoForBeheading(lotNoReq: LotInfoRequest): Promise<LotNumberInfoResponse> {
    try {
      // const lotNoInformation = await this.inventoryRepository.findOne({select:['lotNumber','issuedQuantity','saleOrderId','saleOrderItemId','inputGrade','boxes', 'physicalQuantity'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId, nextOperation:lotNoReq.presentOperation}});
      const lotNoInformation = await this.inventoryRepository.getLotNumberInfoForBeheading(lotNoReq);
      if (lotNoInformation) {
        let availBoxes = lotNoInformation.boxes;
        if (lotNoReq.presentOperation == OperationTypeEnum.BE_HEADING || lotNoReq.presentOperation == OperationTypeEnum.GRADING) {
          const getReportedQty = await this.productionLogService.getOperationQuantity(lotNoReq.lotNumber, lotNoReq.plantId, lotNoReq.presentOperation);
          if (getReportedQty) {

            // availQty = Number(availQty) - Number(getReportedQty.quantity)
            availBoxes = Number(availBoxes) - Number((getReportedQty.boxes > 0 ? Number(getReportedQty.boxes):0));
          }
        }
        
        const boxWeight = (lotNoInformation.physicalQuantity) / (lotNoInformation.boxes?lotNoInformation.boxes:1);
        const soInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: lotNoInformation.saleOrderItemId })

        const lotInfo = new LotNoInfo(lotNoInformation.lotNumber, lotNoInformation.saleOrderId, soInfo.data.saleOrderNo, lotNoInformation.saleOrderItemId, '', lotNoInformation.inputGrade, lotNoInformation.availableQuantity, availBoxes, lotNoInformation.prodInvId, lotNoInformation.inputGrade, lotNoInformation.outputGrade, boxWeight, soInfo.data.soakingTime, soInfo.data.soakingStyle, lotNoInformation.opBoxes);

        return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
      } else {
        throw new ErrorResponse(9999, 'Unable to get lot info')
      }
    } catch (error) {
      return error;
    }
  }


  async getSaleOrdersForLot(lotNoReq: LotInfoRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
    const soIds = await this.inventoryRepository.getSaleOrdersForLot(lotNoReq);
      if (soIds) {
        const saleOrders: SaleOrderDropDownDto[] = [];
        for (const id of soIds) {
          const soReq: saleOrder = {
            saleOrderId: id.saleOrderId
          }
          const saleOrderDetails = await this.saleService.getSaleOrderFewDetailsForSoId(soReq);
          if (!saleOrderDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Sale Order');
          }
          saleOrders.push(saleOrderDetails);
        }
        return new SaleOrderDropDownResponseModel(true, 1111, 'Sale Orders Retrieved Successfully', saleOrders)
      } else {
        throw new ErrorResponse(1111, 'Failed to Get Sale Orders');
      }
    } catch (error) {
      return error
    }
  }


  async getSaleOrderItemsForLotAndSo(lotNoReq: LotInfoRequest): Promise<ItemsDropDownResponseModel> {
    try {
    const soIds = await this.inventoryRepository.getSaleOrderItemsForLotAndSo(lotNoReq);
      if (soIds) {
        const saleOrdersItems: ItemsDropDownDto[] = [];
        for (const id of soIds) {
          const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: id.saleOrderItemId })
          const item = new ItemsDropDownDto(id.saleOrderItemId, soItemInfo.data.product)
         
          saleOrdersItems.push(item);
        }
        return new ItemsDropDownResponseModel(true, 1111, 'Sale Order Items Retrieved Successfully', saleOrdersItems)
      } else {
        throw new ErrorResponse(1111, 'Failed to Get Sale Order Items');
      }
    } catch (error) {
      return error
    }
  }

  // async previousNextOpeartions(inputReq:OperationSequenceRequest){
  //   const oerationSequenceData = await this.getOperationSequence()
  // }

  //   async getLotNumberInfo(lotNoReq:LotInfoRequest):Promise<LotNumberInfoResponse>{
  //     try{

  //       let previousOperation;
  //       let nextOperation;
  //       let presentOperationReportedQty = 0;
  //       let previousOperationReportedQty = 0;
  //       let nextOperationReportedQty = 0;
  //       let soItemId = 1; //need to get from service
  //       const operationSeqData = await this.variantOpService.getOperationSequence(new OperationSequenceRequest(lotNoReq.plantId,lotNoReq.presentOperation,soItemId));
  //       if(operationSeqData.status){
  //         previousOperation = operationSeqData.data.previousOperation;
  //         nextOperation = operationSeqData.data.nextOperation;
  //         const lotNo_present_opInformation = await this.prodInvRepository.findOne({select:['lotNumber','reportedQuantity','saleOrderId','saleOrderItemId','inputGrade'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId,operation:lotNoReq.presentOperation}});
  //         const lotNo_previous_opInformation = await this.prodInvRepository.findOne({select:['lotNumber','reportedQuantity','saleOrderId','saleOrderItemId','inputGrade'],where:{subLotNumber:lotNoReq.lotNumber,plantId:lotNoReq.plantId,operation:previousOperation}});
  //         if(lotNo_present_opInformation){
  //           presentOperationReportedQty = lotNo_present_opInformation.reportedQuantity;
  //         }
  //         let availableQty = lotNo_previous_opInformation.reportedQuantity - presentOperationReportedQty;
  //           if(lotNo_previous_opInformation){
  //             const lotInfo = new LotNoInfo(lotNo_previous_opInformation.lotNumber, lotNo_previous_opInformation.saleOrderId, '', lotNo_previous_opInformation.saleOrderItemId, '', lotNo_previous_opInformation.inputGrade ,availableQty, undefined);
  //             return new LotNumberInfoResponse(true, 1111, 'Lot No Info Retrieved Successfully', lotInfo);
  //           }else{
  //             throw new ErrorResponse(9999, 'Unable to get lot info')
  //           }
  //       }else{
  //         throw new ErrorResponse(9999, 'Unable to get Operation Sequence')
  //       }
  //     }catch(error){
  //       return error;
  //     }
  // }

  async getNoOfAvailableBoxes(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const noOfBoxes = await this.inventoryRepository.getNoOfAvailableBoxes(operation, plantId);
      if (noOfBoxes) {
        return new CommonResponse(true, 1111, 'Available Boxes Found Successfully', noOfBoxes)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getQtyToBeProcessed(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const qty = await this.inventoryRepository.getQtyToBeProcessed(operation, plantId);
      if (qty) {
        return new CommonResponse(true, 1111, 'To Be Processed Quantity Found Successfully', qty)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getInventoryQty(operation: OperationTypeEnum, plantId: number): Promise<CommonResponse> {
    try {
      const qty = await this.inventoryRepository.getInventoryQty(operation, plantId);
      if (qty) {
        return new CommonResponse(true, 1111, 'Inventory Quantity Found Successfully', qty)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }
  async getSubPlantHistoryReportDetails(req?: subplantReportRequest): Promise<SubPlantResponseModel> {

    try {
      const subPlantDetails = this.logRepository.createQueryBuilder('production_log')
        .select([
          'production_log.lot_number as lotNumber,production_log.operation as operation,production_log.sale_order_id as saleOrderId,production_log.assigned_time as assignedTime,production_log.ip_boxes as ipBoxes,production_log.op_boxes as opBoxes,production_log.sub_plant_id as plantName,production_log.job_number as jobNumber,production_log.job_status as jobStatus,production_log.input_grade as inputGrade,production_log.input_quantity as inputQuantity,production_log.sub_plant_op_status as  isReceived'
        ])
      if (req) {
        if (req.fromDate && req.toDate) {
          subPlantDetails.where('Date(assigned_time) between ' + req.fromDate.toString() + ' and ' + req.toDate.toString())
        }

        if (req.soNumber) {
          subPlantDetails.andWhere('sale_order_id =' + req.soNumber)
        }

        if (req.lotNumber) {
          subPlantDetails.andWhere('lot_number ="' + req.lotNumber + '"')
        }

        if (req.operation) {
          subPlantDetails.andWhere(' operation="' + req.operation + '"')
        }

        if (req.jobNumber) {
          subPlantDetails.andWhere('job_number ="' + req.jobNumber + '"')
        }
        if (req.plantName) {
          subPlantDetails.andWhere('sub_plant_id =' + req.plantName)
        }
      }
      const plantDetails = await subPlantDetails.getRawMany();
      if (plantDetails && plantDetails.length > 0) {
        const subPlantArray: subPlantHistoryReport[] = [];

        for (const subPlantInfo of plantDetails) {
          const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: subPlantInfo.saleOrderId })
          const subPlantobj = new subPlantHistoryReport(subPlantInfo.plantName, subPlantInfo.operation, soInfo.saleOrderNumber, subPlantInfo.lotNumber, subPlantInfo.jobNumber, subPlantInfo.ipBoxes, subPlantInfo.opBoxes, subPlantInfo.isReceived, subPlantInfo.inputQuantity, subPlantInfo.inputGrade, subPlantInfo.jobStatus, subPlantInfo.subPlantId)
          subPlantArray.push(subPlantobj)
        }
        const response = new SubPlantResponseModel(true, 1108, 'SubPlantHistory Report Retrieved Succesfully', subPlantArray);
        return response;
      } else {
        throw new ErrorResponse(9999, 'Failed To subPlantHistory Report')
      }
    }
    catch (error) {
      return error;
    }
  }
  async getInventoryInfo(operation: OperationTypeEnum, plantId: number): Promise<ProductionInventoryResponse> {
    try {
      // const response = await this.inventoryRepository.getInventoryInfo(operation, plantId);
      // if (response) {
      //   for (const inv of response) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     inv.saleOrder = soInfo.saleOrderNumber;
      //     inv.poNumber = soInfo.poNumber
      //     // inv.product = (inv.saleOrderItemId).toString();
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     console.log(soItemInfo);
      //     if(soItemInfo.status){
      //       inv.product = soItemInfo.data.product;
      //     }
      //   }

        const manager = getManager();
        const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'gi.plant_lot_number' : 'gi.lot_number'
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var resQuery = `SELECT gi.remarks as plantLotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,pi.lot_number as lotNumber, sub_lot_number as subLotNumber, pi.sale_order_id as saleOrderId, pi.sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, round(physical_quantity) as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, pi.boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, op_boxes as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as count ,sid.po_number as poNumber, p.name as product, sc.variant_code AS productSKU,pi.plant_id AS plantId,lc.quantity as ipQty,lc.count as ipCount,round(pi.stock_transfer_qty) as transferedQuantity, round(pi.physical_quantity - pi.issued_quantity - pi.stock_transfer_qty - pi.conversion_quantity) as qty,round(pi.conversion_quantity) as conversionQty FROM `+ appSettings.production_db+`.production_inventory pi LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.sales_db +`.sale_order_items soi ON soi.sale_order_item_id = pi.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = soi.varient_id LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on ${grnItemColumn}= pi.lot_number LEFT JOIN `+appSettings.production_db + `.lot_code_data lc ON lc.lot_number = pi.lot_number WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}"`
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          resQuery += "AND pi.sub_plant_id="+plantId;
        }else{
          if(plantId && plantId!=5){
              resQuery += "AND pi.plant_id="+plantId+' and pi.sub_plant_id = 0';
          }
          else{  
              resQuery += ' and pi.sub_plant_id = 0';
          }
        }
        resQuery += " Order By pi.lot_number DESC";
        const response =await manager.query(resQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }

  async getStockInventory(operation: OperationTypeEnum, plantId: number,batchNumbers:string[]): Promise<ProductionInventoryResponse> {
    try {
      const lotNumbers = batchNumbers.map(item => '"'+item+'"');
      // const response = await this.inventoryRepository.getInventoryInfo(operation, plantId);
      // if (response) {
      //   for (const inv of response) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     inv.saleOrder = soInfo.saleOrderNumber;
      //     inv.poNumber = soInfo.poNumber
      //     // inv.product = (inv.saleOrderItemId).toString();
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     console.log(soItemInfo);
      //     if(soItemInfo.status){
      //       inv.product = soItemInfo.data.product;
      //     }
      //   }

      // LEFT JOIN `+appSettings.production_db + `.lot_code_data lc ON lc.lot_number = pi.lot_number  // removed left join getting multiple records against lot  lc.quantity as ipQty,lc.count as ipCount these info not using anywhere

        const manager = getManager();
        const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'gi.plant_lot_number' : 'gi.lot_number'
        const versionBasedProduct = GlobalVariableValues.productionVersion == 'V2' ? `pi.product` : `p.name`
        const versionBasedQty = GlobalVariableValues.productionVersion == 'V2' ? `IF(operation = '${OperationTypeEnum.VALUE_ADDITION}' , wip_quantity - issued_quantity - stock_transfer_qty, physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity )` : `(physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity)`
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
        const result =await manager.query(query);
        var resQuery = `SELECT pi.input_grade AS count,pi.prod_inv_id AS prodInvId,pi.conversion_quantity AS conversionQuantity, pi.stock_transfer_qty AS transferedQty, gi.remarks as plantLotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,pi.lot_number as lotNumber, sub_lot_number as subLotNumber, pi.sale_order_id as saleOrderId, pi.sale_order_item_id as saleOrderItemId ,round(issued_quantity) as issuedQuantity, `+versionBasedQty+` as physicalQuantity, round(intransit_quantity) as intransitQuantity, round(wip_quantity) as wipQuantity, round(wastage_quantity) as wastageQuantity, round(rejected_quantity) as rejectedQuantity, pi.boxes as boxes, input_grade as inputGrade, output_grade as outputGrade, operation, IF(op_boxes = 0, (pi.boxes - converted_boxes - transfered_boxes),op_boxes) as opBoxes, prod_inv_id as productionInventoryId, next_operation as nextOperation, output_grade as opcount ,sid.po_number as poNumber, `+versionBasedProduct+` as product, sc.short_code AS productSKU,pi.plant_id AS plantId,prev_operation as previousOperation FROM `+ appSettings.production_db+`.production_inventory pi LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.sales_db +`.sale_order_items soi ON soi.sale_order_item_id = pi.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = soi.varient_id LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on ${grnItemColumn}=pi.lot_number WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}" AND `+versionBasedQty+` > 0`
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          resQuery += " AND pi.sub_plant_id="+plantId;
        }else{
          resQuery += " AND pi.plant_id="+plantId+' and pi.sub_plant_id = 0';
        }
        if(batchNumbers){
          resQuery += ` AND pi.lot_number IN (${lotNumbers})`
        }
        resQuery += " Order By (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) DESC, pi.lot_number DESC";
        const response =await manager.query(resQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getReadyForDeheading(req:unitRequiest): Promise<ProductionInventoryResponse> {
    try {
        const manager = getManager();
        const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'gi.plant_lot_number' : 'gi.lot_number'

        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
        const result =await manager.query(query);
        var DeheadingQuery = `SELECT  p.lot_number AS lotNumber,CONCAT (gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,p.boxes,(p.physical_quantity - p.issued_quantity) AS quantity,p.next_operation AS operation,sc.variant_code AS variantCode,s.varient_id AS variantId,p.prod_inv_id AS productionInventoryId,si.po_number AS poNumber ,p.sale_order_item_id AS saleOrderItemId,p.plant_id FROM `+ appSettings.production_db+`.production_inventory p 
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = p.sale_order_id 
        LEFT JOIN `+appSettings.sales_db +`.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
        LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = s.varient_id 
        LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id 
        LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on ${grnItemColumn} =p.lot_number 
        LEFT JOIN `+appSettings.production_db +`.lot_code_data lc ON lc.lot_number = p.lot_number WHERE p.operation= '${OperationTypeEnum.GRN}' AND p.physical_quantity>0 `
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          DeheadingQuery += "AND p.sub_plant_id="+req.unitId;
        }
        else{
          if(req.unitId && req.unitId!=5){
            DeheadingQuery += "AND p.plant_id="+req.unitId+' and p.sub_plant_id = 0';
          }
          else{
            DeheadingQuery += ' and p.sub_plant_id = 0';
          }
          
        }
        const response =await manager.query(DeheadingQuery); 

      if(response.length > 0 ){

        return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
      }else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }


  async getLotTrackingReportData(req: LotInfoRequest): Promise<LotNumberReportResponseModel> {
    const lotDetails = await this.inventoryRepository.getLotInformation(req);
    for (const lot of lotDetails) {
      // const data = new LotTrackingResponseDto(lot.lotNumber,lot.saleOrderId,"",lot.saleOrderItemId,"",lot.coun)
    }
    return new LotNumberReportResponseModel(false, 1001, "");
  }
  
  async getLotTrackingReportDetails(req: LotInfoRequest): Promise<LotTrackingResponse> {
    try {

      const LotDetails = await this.inventoryRepository.createQueryBuilder('production_Inventory')
        .select([
          'production_Inventory.lot_number as lotNumber,production_Inventory.operation as operation,production_Inventory.sale_order_id as saleOrderId'
        ]).orderBy('production_Inventory.lot_number').where(`lot_number='${req.lotNumber}' and plant_id='${req.plantId}'`).getRawMany();

      if (LotDetails && LotDetails.length > 0) {

        const treeData: TreeStructureData[] = [];
        const lots: string[] = [];

        const lotssos: LotSos[] = [];

        for (const lot of LotDetails) {
          if (!lots.includes(lot.lotNumber)) {
            lots.push(lot.lotNumber)
          }
        }

        for (const lot of lots) {
          const lotSo = new LotSos();
          lotSo.lotNumber = lot;
          const sos: number[] = [];
          LotDetails.filter((lotInfo) => {
            if (lotInfo.lotNumber == lot) {
              if (!sos.includes(lotInfo.saleOrderId)) {
                sos.push(lotInfo.saleOrderId)
              }
            }
          })

          lotSo.soNos = sos;
          lotssos.push(lotSo);
        }


        for (const treeInfo of lotssos) {
          const data = new TreeStructureData();
          data.title = treeInfo.lotNumber
          data.key = 'LOTNumber'
          const soArray: TreeStructureData[] = [];
          for (const so of treeInfo.soNos) {
            const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: so })

            const soData = new TreeStructureData()
            soData.title = soInfo.saleOrderNumber
            soData.key = 'saleOrderId'


            const opArray: TreeStructureData[] = [];
            LotDetails.filter((opInfo) => {

              if (opInfo.lotNumber == treeInfo.lotNumber && opInfo.saleOrderId == so) {
                const opData = new TreeStructureData();
                opData.title = opInfo.operation;
                opData.key = opInfo.operation;
                opData.physicalQuantity = opInfo.physicalQuantity;
                opData.issuedQuantity = opInfo.issuedQuantity;
                opArray.push(opData);
              }

            })
            soData.children = opArray;
            soArray.push(soData);
          }
          data.children = soArray;
          treeData.push(data);
        }

        const response = new LotTrackingResponse(true, 1108, 'LotTracking Report Retrieved Succesfully', treeData);
        return response;
      } else {
        throw new ErrorResponse(9999, 'Failed To LotTracking Report')
      }
    } catch (error) {
      return error;
    }
  }

  async assignRejectionToSo(req?: ProdInvDTO): Promise<ProductionInventoryResponse> {
    return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully')

  }

  async getAllRejections(req:UnitRequest): Promise<ProductionInventoryResponse> {
    try {
      // const responseData: ProductionInventoryDetails[] = [];
      // const prodInvEntities = await this.inventoryRepository.createQueryBuilder('production_inventory')
      //   .where('rejected_quantity > 0').getMany();
      //   console.log(prodInvEntities,"00000")
      // if (prodInvEntities) {
      //   for (const inv of prodInvEntities) {
      //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: inv.saleOrderId })
      //     const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: inv.saleOrderItemId })
      //     const data = new ProductionInventoryDetails(inv.lotNumber, inv.subLotNumber, soInfo.saleOrderNumber, soItemInfo.data.product, inv.boxes, inv.issuedQuantity, inv.physicalQuantity, inv.intransitQuantity, inv.wipQuantity, inv.wastageQuantity, inv.rejectedQuantity, inv.inputGrade, inv.outputGrade, inv.operation, soItemInfo.data.variantCode, soItemInfo.data.variantId, inv.assignedRejection, inv.productionInventoryId,0,null,0,soInfo.poNumber);
      //     responseData.push(data);
      //   }
      //   console.log(responseData,'kkkkkk')
      //   return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully', responseData)
      // } else {
      //   throw new ErrorResponse(9999, 'No Data Found')
      // }
      const manager = getManager();
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.unitId;
      const result = await manager.query(query);
      var responseData = `SELECT CONCAT(p.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, p.lot_number AS lotNumber,p.sub_lot_number AS subLotNumber,p.boxes,p.issued_quantity AS issuedQuantity,p.physical_quantity AS physicalQuantity,p.intransit_quantity AS intransitQuantity,p.wip_quantity AS wipQuantity,p.wastage_quantity AS wastageQuantity,p.rejected_quantity AS rejectedQuantity,p.input_grade AS inputGrade,p.output_grade AS outputGrade,p.operation,sc.variant_code AS variantCode,s.varient_id AS variantId,p.assigned_rejection AS assignedRejection,p.prod_inv_id AS productionInventoryId,so.sale_order_no AS saleOrderNumber,si.po_number AS poNumber ,p.sale_order_id AS saleOrderId,p.sale_order_item_id AS saleOrderItemId FROM `+ appSettings.production_db + `.production_inventory p 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
      LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = s.sale_order_id 
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = s.sale_order_id 
      LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id 
      LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = p.lot_number
      WHERE rejected_quantity > 0 `
      if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.unitId;
      } else {
        responseData += " AND p.plant_id=" + req.unitId + ' AND p.sub_plant_id = 0';
      }
      const response: ProductionInventoryDetails[] = await manager.query(responseData);
      if (response) {
        return new ProductionInventoryResponse(true, 1111, 'Rejections retrived Successfully', response)
      } else {
        throw new ErrorResponse(9999, 'No Data Found')
      }
    } catch (error) {
      return error;
    }
  }

  async getInventoryWipQuantity():Promise<InventoryWipResponse>{
    const invData = await this.inventoryRepository.getInventoryWipData();
    let wipData:WipData[] = []
    if(invData){
      for(const invDataItem of invData){
        const wipDataObj = new WipData(invDataItem.wipQty,invDataItem.saleOrderId,invDataItem.saleOrderItemId);
        wipData.push(wipDataObj);
      }
      return new InventoryWipResponse(true,55555,'WIP quantity retreived',wipData)
    }else{
      return new InventoryWipResponse(false,99999,'No data',undefined)
    }
  }

  async getProcessedLotNumber(req: PlantIdRequest): Promise<LotCodeDropDownResponse> {
    const response:LotCodeDropDown[] = [];
    const processedLotNos = await this.inventoryRepository.getLotCodesData(req);
    for(const item of processedLotNos){
      const data = new LotCodeDropDown(item.lotNumber,item.subLotNumber);
      response.push(data);
    }
    if(response.length>0){
      return new LotCodeDropDownResponse(true,1001,"",response);
    }
    else{
      return new LotCodeDropDownResponse(false,1001,"",response);
    }
  }

  async getOperationWiseLotsInfo(req:UnitRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let lotsDataQry = `SELECT GROUP_CONCAT(sub_lot_number) as lots,operation,ROUND(SUM(wip_quantity)) as wipQty,ROUND(SUM(physical_quantity)) AS inventory FROM ${appSettings.production_db}.production_inventory WHERE STATUS IN('IN_PROGRESS','OPEN') GROUP BY operation`;
      if(req.unitId && req.unitId != 5){
        lotsDataQry += ` and plant_id=` + req.unitId;
      }
      const lotsInfo = await manager.query(lotsDataQry);
      if(lotsInfo.length > 0){
        return new CommonResponse(true,5555,'data retrived',lotsInfo)
      }else{
        return new CommonResponse(false,5555,'data retrived')
      }
    }catch(Err){
      return new CommonResponse(false,4444,Err)
    }

  }

  async lotTrackingInfo():Promise<CommonResponse>{
    try{
      // const 
      return 
    }catch(err){
      return new CommonResponse(false,555,err)
    }
  }

  async getAllSoakingAssets():Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("Select asset_id AS assetId,asset_name AS assetName, asset_code AS assetCode, asset_type AS assetType from "+appSettings.assets_db+".asset a where a.asset_type = 'Soaking'");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getSoakingReport():Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("Select  asset_code AS assetCode,cron_job_time AS cronJobTime,asset_control AS assetControl,created_at AS createdAt,updated_at AS updatedAt,version_flag AS versionFlag,is_active AS isActive,asset_action_control_id AS assetActionControlId,created_user AS createdUser,updated_user AS updatedUser,tub_code AS tubCode,duration_one AS durationOne,duration_two AS durationTwo,tub_status AS tubStatus,asset_status AS assetStatus from "+appSettings.assets_db+".asset_action_control a");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getWipQuantityAgainstsoandsoitem(req:salordeIdandsoItemIdReq):Promise<WipQuantityResponseModel>{
    try{
      const manager = getManager();
      let query = await manager.query("SELECT SUM(wip_quantity) as wipQuantity FROM `erpx_dev_production`.`production_inventory` WHERE sale_order_id = "+req.saleOrderId+" AND sale_order_item_id="+req.saleOrderItemId+" and wip_quantity > 0 GROUP BY sale_order_id,sale_order_item_id");
      if(query.length > 0){
        return new WipQuantityResponseModel(true,1001,"Assets details retrieved successfully. ",query);
      }
      else{
        return new WipQuantityResponseModel(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }
  async getphysicalquantityforlotnumber(req:LotAndOperationReq):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = await manager.query("SELECT prod_inv_id,lot_number AS lotNumber,operation,ROUND(physical_quantity) AS physicalQuantity FROM production_inventory WHERE lot_number= '"+req.lotNumber+"' AND OPERATION= '"+req.operation+"'");
      if(query.length > 0){
        return new CommonResponse(true,1001,"Data Retrieved Sucessfullyy.. ",query);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }catch(err){
      return err
    }
  }

  async getProductionLogReport(req?:ProductionLogRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = "SELECT pl.lot_number AS lotNumber,si.po_number AS poNumber,DATE(pl.created_at) AS DATE,pl.sub_lot_number AS subLotNumber, pl.sale_order_id AS saleOrderId,pl. sale_order_item_id AS saleOrderItemId ,pl.input_grade AS inputGrade,ROUND(input_quantity)AS inputQuantity,ROUND(SUM(planned_output_quantity)) AS plannedOutputQuantity,ROUND(SUM(actual_output_quantity )) AS actualOutputQuantity,ROUND(SUM(p.intransit_quantity)) AS intransitQuantity,ROUND(SUM(pl.wastage_quantity)) AS wastageQuantity,ROUND(SUM(pl.rejected_quantity)) AS rejectedQuantity,ROUND(SUM(p.wip_quantity)) AS wipQuantity,ip_boxes AS ipBoxes,pl.op_boxes AS opBoxes,pl.operation, production_log_id AS productionLogId,pl.job_status AS jobStatus FROM `production_log` pl LEFT JOIN `production_inventory` p ON pl.sale_order_id = p.sale_order_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` si ON si.sale_order_id = pl.sale_order_id WHERE production_log_id >0 "

      if(req.unitId && req.unitId != 5){
        if(req.lotNumber == undefined && req.fromDate == undefined && req.toDate == undefined){
        query = query+  'and pl.plant_id = '+req.unitId;

        }
        if(req.lotNumber){
          query=query+' AND pl.lot_number = "'+req.lotNumber+'" and pl.plant_id = '+req.unitId
        }
        if(req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.plant_id = '+req.unitId;
        }
        if(req.lotNumber && req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" and pl.plant_id = '+req.unitId ;
        }
      }
      else{
           if(req.lotNumber){
          query=query+' AND pl.lot_number= "'+req.lotNumber;
        }
        if(req.fromDate && req.toDate){
            query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate ;
        }
        if(req.lotNumber && req.fromDate && req.toDate){
          query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber ;
      }
      }
     
      const data=await manager.query(query+' GROUP BY pl.lot_number,pl.sale_order_item_id')      

      if(data){
        return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }
    catch(err){
      return err
    }
  }


  async getProductionInventoryReport(req?:ProductionLogRequest):Promise<CommonResponse>{
    try{
      const manager = getManager();
      let query = "SELECT si.po_number as poNumber,lot_number AS lotNumber, sub_lot_number AS subLotNumber,DATE(p.created_at) AS DATE, p.sale_order_id AS saleOrderId, sale_order_item_id AS saleOrderItemId ,ROUND(issued_quantity) AS issuedQuantity, ROUND(physical_quantity) AS physicalQuantity, ROUND(intransit_quantity) AS intransitQuantity, ROUND(wip_quantity) AS wipQuantity, ROUND(wastage_quantity) AS wastageQuantity, ROUND(rejected_quantity) AS rejectedQuantity, boxes AS boxes, input_grade AS inputGrade, output_grade AS outputGrade, operation, op_boxes AS opBoxes, prod_inv_id AS productionInventoryId, next_operation AS nextOperation, output_grade AS COUNT,p.product as product FROM "+appSettings.production_db+".production_inventory p left join "+appSettings.sales_db+".so_invoice_details si on p.sale_order_id=si.sale_order_id where prod_inv_id > 0 "

      if(req.lotNumber){
        query=query+' ANd lot_number= "'+req.lotNumber+'"'
      }
      if(req.fromDate && req.toDate){
          query=query+' And DATE(p.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"';
      }
      if(req.lotNumber && req.fromDate && req.toDate){
        query=query+' And DATE(p.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and lot_number= "'+req.lotNumber+'"' ;
    }
    if(req.operation){
      query=query+' ANd p.operation= "'+req.operation+'"'
    }
    if(GlobalVariableValues.productionVersion == 'V1'){
      query += ` GROUP BY lot_number,sale_order_item_id`
    }
     
      const data=await manager.query(query)      

      if(data.length > 0){
        return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
      }
      else{
        return new CommonResponse(false,1010,"No data found. ");
      }
    }
    catch(err){
      return err
    }
  }

  // async getLotTrackingReport(req?:ProductionLogRequest):Promise<CommonResponse>{
  //   try{
  //     const manager = getManager();
  //     let query = "SELECT p.lot_number,physical_quantity,issued_quantity,p.operation,pl.job_number,pl.workstation,pl.job_status, pl.assigned_time FROM `erpx_dev_production`.`production_inventory` p LEFT JOIN `erpx_dev_production`.`production_log` pl ON pl.sale_order_id = p.sale_order_id WHERE p.prod_inv_id > 0 "

  //     if (req.unitId && req.unitId != 5) {
  //       query = query + ' and pl.plant_id = ' + req.unitId;
  //       if(req.lotNumber){
  //         query=query+' AND p.lot_number = "'+req.lotNumber+'"'
  //       }
  //     }
  //     else{
  //         if(req.lotNumber){
  //           query=query+' AND p.lot_number = "'+req.lotNumber+'"'
  //         }
      
        
  //     }
     
  //     const data=await manager.query(query)      

  //     if(data.length > 0){
  //       return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
  //     }
  //     else{
  //       return new CommonResponse(false,1010,"No data found. ");
  //     }
  //   }
  //   catch(err){
  //     return err
  //   }
  // }

  async getLotInfo(req?: ProductionLogRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = "SELECT si.po_number as poNumber,p.lot_number AS lotNumber, p.sub_lot_number AS subLotNumber, p.sale_order_id AS saleOrderId, p.sale_order_item_id AS saleOrderItemId ,ROUND(p.issued_quantity) AS issuedQuantity, ROUND(p.physical_quantity) AS physicalQuantity, ROUND(p.intransit_quantity) AS intransitQuantity, ROUND(p.wip_quantity) AS wipQuantity, ROUND(p.wastage_quantity) AS wastageQuantity, ROUND(p.rejected_quantity) AS rejectedQuantity,ROUND(p.stock_transfer_qty) as transferedQuantity, p.boxes AS boxes, p.input_grade AS inputGrade, p.output_grade AS outputGrade, p.operation, p.op_boxes AS opBoxes, p.prod_inv_id AS productionInventoryId, p.next_operation AS nextOperation, p.output_grade AS COUNT,p.product,pl.rejection_from AS rejectionFrom,pl.is_rrp AS isRRP FROM " + appSettings.production_db + ".production_inventory p LEFT JOIN " + appSettings.production_db + ".production_log pl ON pl.sale_order_id=p.sale_order_id left join " + appSettings.sales_db + ".so_invoice_details si on p.sale_order_id=si.sale_order_id where p.prod_inv_id > 0 "
 
      if (req.lotNumber) {
        query = query + ' ANd p.lot_number= "' + req.lotNumber + '"';
      }
      const data = await manager.query(query)

      if (data.length > 0) {
        return new CommonResponse(true, 1001, "Lot Info retrieved successfully. ", data);
      }
      else {
        return new CommonResponse(false, 1010, "No data found. ");
      }
    }
    catch (err) {
      return err
    }
  }

  async getInventoryLots(req: LotNumberRequest): Promise<LotCodeDropDownResponse> {
    try {
      const manager = getManager()
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.plant;
      const result = await manager.query(query);
      var responseData = `SELECT p.lot_number  AS lotNumber,gi.remarks AS plantLotNumber,p.sub_lot_number AS subLotNumber FROM `+ appSettings.production_db + `.production_inventory p LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number= p.lot_number WHERE p.prod_inv_id > 0  `

      if (req.operation === "REJECTION") { 
        responseData += ` and rejected_quantity > 0 `;
      }
      else{
        responseData += ` and (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) > 0 `;
      }
      if (req.operation != "GRN" && req.operation != "REJECTION") {
        responseData += ` and next_operation = '`+req.operation+`'`;
      }
      else if (req.operation === "GRN") {
        responseData += ` and operation = '`+req.operation+`'`;
      }
      if (result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.plant;
      } else {
        responseData += " AND p.plant_id=" + req.plant + ' AND p.sub_plant_id = 0';
      }
      responseData += " group by p.lot_number"
      const response = await manager.query(responseData);
      if (response && response.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', response)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  async getSaleOrdersByLot(req: LotCodeRequest): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const query = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id=' + req.plantId;
      const result = await manager.query(query);
      var responseData = `SELECT CONCAT (p.sub_lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as sublotandplantlot,p.output_grade,p.prod_inv_id AS prodInvId,si.sale_order_id AS saleOrderId, si.sale_order_item_id AS saleOrderItemId, sid.po_number AS poNumber, sku.variant_code AS productSKU,mb.brand_name AS brand, pm.packing_method_name AS packStyleId,`
      if(req.presentOperation === "REJECTION"){
        responseData += ` rejected_quantity AS quantity, 0 AS boxes`;
      }
      else{
        responseData += ` (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) AS quantity, IF(p.operation = "GRN",(p.boxes-converted_boxes - transfered_boxes),(op_boxes-converted_boxes - transfered_boxes)) AS boxes`;
      }
      responseData += ` FROM `+ appSettings.production_db + `.production_inventory p left join `+appSettings.rm_procure_db+`.grn_items gi on p.lot_number=gi.lot_number left join `+appSettings.sales_db+`.sale_order_items si on si.sale_order_item_id = p.sale_order_item_id left join `+appSettings.masters_db+`.sku_codes sku on sku.sku_code_id = si.varient_id left join `+appSettings.sales_db+`.so_invoice_details sid on sid.sale_order_id = p.sale_order_id left join `+appSettings.masters_db+`.packing_methods pm on pm.packing_method_id = si.pack_style_id left join `+appSettings.masters_db+`.master_brands mb on mb.master_brand_id = si.master_brand_id WHERE p.lot_number = '`+req.lotNumber+`' and sku.is_active=1`;
      if(req.presentOperation === "REJECTION"){
        responseData += ` and rejected_quantity > 0`;
      }
      else{
        responseData += ` and (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) > 0`;
      }
      if (req.presentOperation != "GRN" && req.presentOperation != "REJECTION") {
        responseData += ` and p.next_operation = '`+req.presentOperation+`'`;
      }
      else if (req.presentOperation === "GRN") {
        responseData += ` and p.operation = '`+req.presentOperation+`'`;
      }
      if(result[0].plant_type == UnitTypeEnum.SUB_PLANT) {
        responseData += " AND p.sub_plant_id=" + req.plantId;
      } else {
        responseData += " AND p.plant_id=" + req.plantId + ' AND p.sub_plant_id = 0';
      }
      const response = await manager.query(responseData);
      if (response && response.length) {
        return new CommonResponse(true, 1111, 'Lot Numbers retrieved successfully', response)
      } else {
        return new CommonResponse(false, 1110, 'Something went wrong')
      }

    } catch (error) {
      return error
    }
  }

  async createGrnRecordAfterReweighment(req:GrnInfoReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    const manager = getManager()
    try{
      await transactionManager.startTransaction()
      let grnInfoQry
      if(req.addonCount){
        grnInfoQry = `SELECT g.supplier_type AS supplierType,g.grn_date AS grnDate,g.grn_number AS grnNumber,g.plant_id AS plantId,g.sub_plant_id AS subPlantId,gi.farmer AS farmer,gi.farmer_code AS farmerCode,gi.sale_order_id AS saleOrderId,gi.sale_order_item_id AS saleOrderItemId,gi.quantity,gi.count,gi.price,gi.boxes,gi.indent_id AS indentId,gi.reweighment_quantity as reweighmentQty
        FROM ${appSettings.rm_procure_db} .grn g
        LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.grn_id = g.grn_id
        WHERE g.grn_id = ${req.grnId}`
      }else{
        grnInfoQry = `SELECT g.supplier_type AS supplierType,g.grn_date AS grnDate,g.grn_number AS grnNumber,g.plant_id AS plantId,g.sub_plant_id AS subPlantId,gi.farmer AS farmer,gi.farmer_code AS farmerCode,gi.sale_order_id AS saleOrderId,gi.sale_order_item_id AS saleOrderItemId,gi.quantity,gi.count,gi.price,gi.boxes,gi.indent_id AS indentId,gi.reweighment_quantity as reweighmentQty
       FROM ${appSettings.rm_procure_db} .grn_items gi
       LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id
       WHERE gi.grn_item_id = '${req.grnItemId}'`
      }
      const grnInfo = await manager.query(grnInfoQry)

      const prodObj = new ProductionInventory()
      prodObj.operation = req.operation
      prodObj.prevOperation = req.operation
      prodObj.inputGrade = String(req.inputGrade)
      prodObj.physicalQuantity = req.physicalQty
      prodObj.subLotNumber = req.batchNumber
      prodObj.lotNumber = req.batchNumber
      prodObj.plantId = req.plantId
      prodObj.createdUser = req.createdUser
      prodObj.year = req.year
      const prodInventorySave = await transactionManager.getRepository(ProductionInventory).save(prodObj)
      if(prodInventorySave){
           // job number generation 
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let fromDate = 0;
      let toDate = 0;
      let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.GRN } })).length;


      if (CurrentMonth < 4) {
        fromDate = (CurrentYear-1);
        toDate = (CurrentYear);
      } else {
        fromDate = (CurrentYear);
        toDate = (CurrentYear + 1);
      }

      totalRecords = totalRecords + 1;

      var refNo = totalRecords + "";
      while (refNo.length < 4) refNo = "0" + refNo;

      const grnJobNo = "GRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

        const prodLogObj = new ProductionLog()
        prodLogObj.lotNumber = req.batchNumber
        prodLogObj.subLotNumber = req.batchNumber
        prodLogObj.operationType = req.operation
        prodLogObj.jobNumber = grnJobNo
        prodLogObj.plantId = req.plantId
        prodLogObj.jobStatus = JobCompletedEnum.YES
        prodLogObj.assignCooking = false
        prodLogObj.inputGrade = String(req.inputGrade)
        prodLogObj.inputQuantity = req.physicalQty
        prodLogObj.prodInvId = prodInventorySave.productionInventoryId
        prodLogObj.createdUser = req.createdUser
        prodLogObj.prevOperation = OperationTypeEnum.GRN
        prodLogObj.year = req.year
        const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
        if(prodLogSave){

          const lotCodeOps = new LotCodeOpsEntity();
          lotCodeOps.grnDate = grnInfo[0].grnDate;
          lotCodeOps.indentId = grnInfo[0].indentId;
          lotCodeOps.grnNumber = grnInfo[0].grnNumber;
          lotCodeOps.saleOrderId = grnInfo[0].saleOrderId;
          lotCodeOps.saleOrderItemId = grnInfo[0].saleOrderItemId;
          lotCodeOps.supplierType = grnInfo[0].supplierType;
          lotCodeOps.farmer = grnInfo[0].farmer;
          lotCodeOps.farmerCode = grnInfo[0].farmerCode;
          lotCodeOps.quantity = req.physicalQty
          lotCodeOps.count = req.inputGrade
          lotCodeOps.price = grnInfo[0].price;
          lotCodeOps.boxes = grnInfo[0].boxes;
          lotCodeOps.plantId = grnInfo[0].plantId;
          lotCodeOps.subPlantId = grnInfo[0].subPlantId;
          lotCodeOps.isActive = true;
          lotCodeOps.createdUser = req.createdUser;
          lotCodeOps.lotNumber = req.batchNumber;
          lotCodeOps.year = req.year;
          lotCodeOps.mainLotNum = req.mainBatchNumber
          lotCodeOps.mainLotAfterClub = req.mainBatchNumber
          lotCodeOps.grnTestResult = req.antibioticTestResult

    
          const savedLotCodeOpsEntity: LotCodeOpsEntity = await transactionManager.getCustomRepository(LotCodeOpsRepository).save(
            lotCodeOps
          );
          if(savedLotCodeOpsEntity){
            await transactionManager.completeTransaction()
            return new CommonResponse(true,1,'Saved successfully')
          }else{
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in Lot Code Info Saving')
          }
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in Production Log Saving')
        }
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong in produciton Inventory saving')
      }
      
    }catch(err){
      await transactionManager.releaseTransaction()
      throw err
    }
  }

  async createDeheadingReporting(request:OperationReportingReq[]):Promise<CommonResponse>{
    console.log(request,"request backend  deheading")
    const transactionManager = new GenericTransactionManager()
    const queryManager = getManager()
    try{

      // const getCustomerCountTypeQry = `SELECT rate FROM ${appSettings.masters_db} .deheading_rates WHERE contractor_id = ${req.contractorId}`
      // const contractorInfo = await queryManager.query(getCustomerCountTypeQry)
      // let contractorRateInfo
      // if(contractorInfo.length > 1){
      //   const customerRateQry = `SELECT rate FROM ${appSettings.masters_db} .deheading_rates WHERE contractor_id = ${req.contractorId} AND ${req.count} >= min_count AND ${req.count} <= max_count`
      //   contractorRateInfo = await queryManager.query(customerRateQry)
      // }
      await transactionManager.startTransaction()
      const saveFlag = new Set<boolean>()
      let productionLogId
      const findPrevBillInfo = await transactionManager.getRepository(ProductionLog).find({where:{billNo:request[0].billNo}})
      for(const req of request){
        const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(req.plantId))
        let getPrevRecord
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
          getPrevRecord = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,lotNumber:req.batchNumber,subPlantId:req.plantId,year:req.year}})
        }else{
          getPrevRecord = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,lotNumber:req.batchNumber,plantId:req.plantId,subPlantId:0,year:req.year}})
        }
        if(getPrevRecord.length == 0 && req.prevOperation != OperationTypeEnum.PACKING){
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'No RM quantity identified with selected count')
        }
  
        const prevDeheadingInfo = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.batchNumber,operation:req.operation,inputGrade:req.count,year:req.year}})
  
        const prodInvObj = new ProductionInventory()
  
        if(result.data.plantType == UnitTypeEnum.PLANT){
          prodInvObj.subPlantId = 0
          prodInvObj.plantId = req.plantId;
        }
        if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
            prodInvObj.subPlantId = req.plantId;
            prodInvObj.plantId = getPrevRecord[0].plantId;
  
        }
        
        if(prevDeheadingInfo.length > 0){
          prodInvObj.physicalQuantity = Number(prevDeheadingInfo[0].physicalQuantity) + Number(req.reportedQty)
          prodInvObj.productionInventoryId = prevDeheadingInfo[0].productionInventoryId
          prodInvObj.updatedUser = req.createdUser
        }else{
          prodInvObj.plantId = req.plantId
          prodInvObj.createdUser = req.createdUser
          prodInvObj.operation = req.operation
          prodInvObj.prevOperation = req.prevOperation
          prodInvObj.lotNumber = req.batchNumber
          prodInvObj.subLotNumber = req.batchNumber
          prodInvObj.inputGrade = String(req.count)
          prodInvObj.physicalQuantity = req.reportedQty
          prodInvObj.product = 'HL'
          prodInvObj.year = req.year
          prodInvObj.processType = req.processType
        }
  
        const prodInvSave = await transactionManager.getRepository(ProductionInventory).save(prodInvObj)
        if(prodInvSave){
        // job number generation 
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let toDate = 0;
        let totalRecords = await (await this.logRepository.find({ where: { operationType: req.operation } })).length;
  
  
        if (CurrentMonth < 4) {
          fromDate = (CurrentYear-1);
          toDate = (CurrentYear);
        } else {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        }
  
        totalRecords = totalRecords + 1;
  
        var refNo = totalRecords + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        const grnJobNo = 'DEHEAD' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
          const prodLogObj = new ProductionLog()
          prodLogObj.lotNumber = req.batchNumber
          prodLogObj.subLotNumber = req.batchNumber
          prodLogObj.operationType = req.operation
          prodLogObj.jobNumber = grnJobNo
          prodLogObj.plantId = req.plantId
          prodLogObj.jobStatus = JobCompletedEnum.YES
          prodLogObj.assignCooking = false
          prodLogObj.inputGrade = String(req.count)
          // prodLogObj.inputQuantity = req.reportingType == DeheadingReportingTypeEnum.FULL && req.prevOperation != OperationTypeEnum.PACKING ? getPrevRecord[0].physicalQuantity : Number(req.reportedQty) / (70/100)
          prodLogObj.inputQuantity = Number(req.reportedQty) / (70/100)
          prodLogObj.actualOutputQuantity = req.reportedQty
          prodLogObj.prodInvId = prodInvSave.productionInventoryId
          prodLogObj.reportingType = req.reportingType
          prodLogObj.workStation = req.workStation
          prodLogObj.shift = req.shift
          prodLogObj.createdUser = req.createdUser
          prodLogObj.assignedUser = req.createdUser
          prodLogObj.prevOperation = req.prevOperation
          prodLogObj.plantId = prodInvSave.plantId
          prodLogObj.subPlantId = prodInvSave.subPlantId
          prodLogObj.product = 'HL'
          prodLogObj.contractorId = req.contractorId
          prodLogObj.billNo = req.billNo
          prodLogObj.unitPrice = req.deheadingRate
          prodLogObj.date = req.date
          prodLogObj.billType = 'HeadON'
          prodLogObj.amount = Number(req.deheadingRate) * Number(req.reportedQty)
          prodLogObj.reason = req.reason
          prodLogObj.noOfPersons = findPrevBillInfo.length > 0 && findPrevBillInfo[0]?.noOfPersons > 0 ? findPrevBillInfo[0].noOfPersons : req.noOfPersons
          prodLogObj.year = req.year
          prodLogObj.processType = req.processType
          const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
          productionLogId = prodLogSave.productionLogId
          if(prodLogSave){
            if(req.prevOperation != OperationTypeEnum.PACKING){
              let issuedQty
              if(req.reportingType == DeheadingReportingTypeEnum.FULL){
                issuedQty = Number(getPrevRecord[0].physicalQuantity) 
              }else{
                issuedQty = Number(req.reportedQty) / (70/100) + Number(getPrevRecord[0].issuedQuantity)
              }
              const updateIssueQty = await transactionManager.getRepository(ProductionInventory).update({productionInventoryId:getPrevRecord[0].productionInventoryId},{issuedQuantity:issuedQty})
              if(!updateIssueQty.affected){
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in Updating issued qty')
              }
            }
  
           
  
          }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in Production Log Saving')
          }
        }else{
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in produciton Inventory saving')
        }
      }
      if(!saveFlag.has(false)){
        let workersSaveFalg = new Set<boolean>()
        if(request[0].workersInfo !=undefined){
          for(const rec of request[0].workersInfo){
            const workersObj = new ProductionWorkersEntity()
            workersObj.contractorId = rec.contractorId
            workersObj.contractorName = rec.contractorName
            workersObj.empCode = rec.workerCode
            workersObj.empId = rec.workerId
            workersObj.empName = rec.workerName
            workersObj.village = rec.village
            workersObj.productionLogId = productionLogId
            workersObj.transportation = rec.transportation
            workersObj.billNo = request[0].billNo
            workersObj.transportCharges = rec.transportation == 'Auto' ? rec.transportCost  : 0
            workersObj.operation = OperationTypeEnum.BE_HEADING
            workersObj.avgQty = request[0].avgQty
            workersObj.avgWage = request[0].avgWage
            const peelingWorkersInfoSave = await transactionManager.getRepository(ProductionWorkersEntity).save(workersObj)
            if(peelingWorkersInfoSave){
              workersSaveFalg.add(true) 
            }else{
              workersSaveFalg.add(false)
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in saving peeling workers info')
            }
          }
        }
        if(!(workersSaveFalg.has(false))){
          await transactionManager.completeTransaction()
        return new CommonResponse(true,1,'Saved successfully')
        }else{
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving peeling workers info')
        }
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong')
      }
    }catch(err){
      console.log(err,'----')
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong',err)
    }
  }

  async getBatchNumberDropdown(req: LotNumberRequest):Promise<LotCodeDropDownResponse>{
    try{
      const manager = getManager()
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
      const result =await manager.query(query);
      let str = '';
      let date 
      const now = new Date();
        const fiveDaysAgo = new Date(now);
        fiveDaysAgo.setDate(now.getDate() - 5);
        date = moment(fiveDaysAgo).format('YYYY-MM-DD')
      if(req.tabName == OperationTypeEnum.GRADING && req.operation == OperationTypeEnum.BE_HEADING){
        str = ` inner join ${appSettings.production_db} .production_log pl on pl.prod_inv_id = p.prod_inv_id and reporting_type= 'FULL'`;
      }
      // if(req.operation == OperationTypeEnum.SOAKING){
        
      //   str = ` left join ${appSettings.rm_procure_db} .grn_items grni on grni.plant_lot_number = p.lot_number and grni.year = p.year`
      // }

      let infoQuery = `SELECT p.prod_inv_id AS prodInvId,p.lot_number as lotNumber,p.sub_lot_number as subLotNumber,p.year from ${appSettings.production_db} .production_inventory p
      ${str} 
       left join ${appSettings.rm_procure_db} .grn_items grni on grni.plant_lot_number = p.lot_number and grni.year = p.year
      where p.prod_inv_id > 0 and DATE(grni.reweighment_date) >= '${date}' `
    //   ((p.operation = '${OperationTypeEnum.VALUE_ADDITION}' AND p.wip_quantity > 0)
    //   OR
    //   (p.operation = '${OperationTypeEnum.SOAKING}')
    //   OR
    //   (p.operation NOT IN ('${OperationTypeEnum.VALUE_ADDITION}', '${OperationTypeEnum.SOAKING}') AND p.physical_quantity > 0))
    // #IF(p.operation = '${OperationTypeEnum.VALUE_ADDITION}'  OR p.operation = '${OperationTypeEnum.SOAKING}'  , p.wip_quantity  > 0,p.physical_quantity > 0)
      if(req.operation != OperationTypeEnum.COOKING && req.operation != undefined){
        infoQuery += ` and p.operation = '${req.operation}'`
      }
      if(req.operation == OperationTypeEnum.VALUE_ADDITION){
        infoQuery += ` and p.wip_quantity > 0`
      }
      if(req.operation != OperationTypeEnum.SOAKING && req.operation != OperationTypeEnum.VALUE_ADDITION){
        infoQuery += ` and p.physical_quantity > 0`
      }
      // if(req.tabName == OperationTypeEnum.GRADING){
      //   infoQuery += ` and pl.reporting_type = '${DeheadingReportingTypeEnum.FULL}'`
      // }
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        infoQuery += ` AND p.sub_plant_id= ${req.plant}`;
      }else{
        infoQuery += ` AND p.plant_id= ${req.plant} and p.sub_plant_id = 0`
      }
      infoQuery += ` group by p.sub_lot_number,year`
      const info = await manager.query(infoQuery)
      const data: LotCodeDropDown[] = []
      if(info.length > 0){
        for(const rec of info){
          data.push(new LotCodeDropDown(rec.lotNumber,rec.subLotNumber,null,null,rec.subLotNumber,null,rec.year,rec.prodInvId))
        }
        return new LotCodeDropDownResponse(true,1,'Data retrieved successfully',data)
      }else{
        return new LotCodeDropDownResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async createValueAdditionIssuing(request:OperationReportingReq[]):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    const manager = getManager()
    try{
      // const request = JSON.parse(requestFormat)
      await transactionManager.startTransaction()
      let flag = new Set<boolean>()
      let productionLogId
      const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(request[0].plantId))
      let saveFlag = new Set<boolean>()
      const findPrevBillInfo = await transactionManager.getRepository(ProductionLog).find({where:{billNo:request[0].billNo}})
      for(const req of request){
        if(req.prevOperation != OperationTypeEnum.PACKING){
          // After Grading process only value addition process will there,as grading(HL) qty only we can track ,need to validate qty with grading output qty
          let getQtyAtPrevOperation
          if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.GRADING,lotNumber:req.batchNumber,outputGrade:req.count,subPlantId:req.plantId,year:req.year}})
          }else{
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.GRADING,lotNumber:req.batchNumber,outputGrade:req.count,plantId:req.plantId,subPlantId:0,year:req.year}})
          }
    
          
          let gradedQty = getQtyAtPrevOperation[0]?.physicalQuantity - getQtyAtPrevOperation[0]?.issuedQuantity
          if(!req.isRRP){
            if(Number(req.reportedQty) > gradedQty){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,`Issued quantity sholud be less than available HL quantity for ${req.batchNumber}-${req.year} and count ${req.count}`)
            }
          }
        }
        let getPrevRec
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
         getPrevRec = await transactionManager.getRepository(ProductionInventory).find({where:{prevOperation : req.prevOperation,operation:req.operation,inputGrade:req.count,subLotNumber:req.batchNumber,product:req.product,subPlantId:req.plantId,year:req.year,isRRP:req.isRRP}})
        }else{
          getPrevRec = await transactionManager.getRepository(ProductionInventory).find({where:{prevOperation : req.prevOperation,operation:req.operation,inputGrade:req.count,subLotNumber:req.batchNumber,product:req.product,plantId:req.plantId,subPlantId:0,year:req.year,isRRP:req.isRRP}})
        }
        let saveProdInv
        const prodInvObj = new ProductionInventory()
        if(getPrevRec.length == 0){
          if(result.data.plantType == UnitTypeEnum.PLANT){
            prodInvObj.subPlantId = 0
            prodInvObj.plantId = req.plantId;
          }
          if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
              prodInvObj.subPlantId = req.plantId;
              prodInvObj.plantId = getPrevRec[0].plantId;
          }
          prodInvObj.prevOperation = req.prevOperation
          prodInvObj.operation = req.operation
          prodInvObj.lotNumber = req.batchNumber
          prodInvObj.subLotNumber = req.batchNumber
          prodInvObj.inputGrade = String(req.count)
          prodInvObj.createdUser = req.createdUser
          prodInvObj.product = req.product
          prodInvObj.wipQuantity = req.reportedQty
          prodInvObj.physicalQuantity = req.outputQuantity ? req.outputQuantity : 0
          prodInvObj.boxes = req.boxes
          prodInvObj.year = req.year
          prodInvObj.processType = req.processType
          prodInvObj.isRRP = req.isRRP
        }else{
          prodInvObj.productionInventoryId = getPrevRec[0].productionInventoryId
          prodInvObj.updatedUser = req.createdUser
          prodInvObj.wipQuantity = Number(req.reportedQty) + Number(getPrevRec[0].wipQuantity)
          prodInvObj.boxes = Number(req.boxes ? req.boxes : 0) + Number(getPrevRec[0].boxes)
          prodInvObj.physicalQuantity = Number(req.outputQuantity ? req.outputQuantity : 0) + Number(getPrevRec[0].physicalQuantity)

        }
        saveProdInv = await transactionManager.getRepository(ProductionInventory).save(prodInvObj)
        if(!saveProdInv){
          saveFlag.add(false)
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving in production invenotry')
        }else{
          saveFlag.add(true)
        }
  
        if(req.prevOperation == OperationTypeEnum.GRADING){
          let getPrevOperationRec
          if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
           getPrevOperationRec = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,subLotNumber:req.batchNumber,outputGrade:req.count,subPlantId:req.plantId,year:req.year}})
          }else{
             getPrevOperationRec = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,subLotNumber:req.batchNumber,outputGrade:req.count,plantId:req.plantId,subPlantId:0,year:req.year}})
          }
          if(getPrevOperationRec.length == 0){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'No Gradng quantity identified with selected count')
          }
  
          let updateIssuedQty
          if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
           updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({operation:req.prevOperation,subLotNumber:req.batchNumber,outputGrade:String(req.count),subPlantId:req.plantId,year:req.year},{issuedQuantity:Number(req.reportedQty) + Number(getPrevOperationRec[0].issuedQuantity)})
          }else{
            updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({operation:req.prevOperation,subLotNumber:req.batchNumber,outputGrade:String(req.count),plantId:req.plantId,subPlantId:0,year:req.year},{issuedQuantity:Number(req.reportedQty) + Number(getPrevOperationRec[0].issuedQuantity)})
          }
          if(!updateIssuedQty.affected){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in updating issued quantity')
          }
  
            // job number generation 
        let today = new Date();
        let CurrentYear = today.getFullYear();
        let CurrentMonth = today.getMonth();
        let fromDate = 0;
        let toDate = 0;
        let totalRecords = await (await this.logRepository.find({ where: { operationType: req.operation } })).length;
  
  
        if (CurrentMonth < 4) {
          fromDate = (CurrentYear-1);
          toDate = (CurrentYear);
        } else {
          fromDate = (CurrentYear);
          toDate = (CurrentYear + 1);
        }
  
        totalRecords = totalRecords + 1;
  
        var refNo = totalRecords + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        const grnJobNo = 'VALUEADD' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
  
          const prodLogObj = new ProductionLog()
          prodLogObj.lotNumber = req.batchNumber
          prodLogObj.subLotNumber = req.batchNumber
          prodLogObj.operationType = req.operation
          prodLogObj.jobNumber = grnJobNo
          prodLogObj.jobStatus = JobCompletedEnum.NO
          prodLogObj.assignCooking = false
          prodLogObj.inputGrade = String(req.count)
          prodLogObj.inputQuantity = req.reportedQty
          prodLogObj.prodInvId =getPrevRec.length > 0 ? getPrevRec[0].productionInventoryId :  saveProdInv.productionInventoryId
          prodLogObj.plantId = getPrevRec.length > 0 ? getPrevRec[0].plantId : saveProdInv.plantId
          prodLogObj.subPlantId = getPrevRec.length > 0 ? getPrevRec[0].subPlantId : saveProdInv.subPlantId
          prodLogObj.workStation = req.workStation
          prodLogObj.shift = req.shift
          prodLogObj.createdUser = req.createdUser
          prodLogObj.assignedUser = req.createdUser
          prodLogObj.product = req.product
          prodLogObj.prevOperation = req.prevOperation
          prodLogObj.inputBoxes = req.boxes
          prodLogObj.billType = 'Peeling'
          prodLogObj.billNo = req.billNo
          prodLogObj.date = req.date
          prodLogObj.noOfPersons = findPrevBillInfo.length > 0 && findPrevBillInfo[0]?.noOfPersons > 0 ? findPrevBillInfo[0].noOfPersons : req.noOfPersons
          prodLogObj.scopeOfWork = req.scopeOfWork
          prodLogObj.contractorId = req.contractorId
          prodLogObj.actualOutputQuantity= req.outputQuantity
          prodLogObj.peelingPriceBasedOn = req.peelingPriceBasedOn
          // prodLogObj.averageQty =  Number(req.reportedQty) / Number(req.noOfPersons)
          prodLogObj.unitPrice = req.peelingRate
          prodLogObj.amount = req.outputQuantity > 0 ?  Number(req.peelingRate) * Number(req.outputQuantity) : Number(req.peelingRate) * Number(req.reportedQty)
          prodLogObj.year = req.year
          prodLogObj.processType = req.processType
          const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
         
          if(!prodLogSave){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in saving in production log')
          }else{
            productionLogId = prodLogSave.productionLogId
          }

        }
        else if(req.prevOperation == OperationTypeEnum.COOKING){
          const getSoakStyleQry = `SELECT soaking_style as soakStyle,grade_name as grade, short_code as product,f.food_type as foodType FROM ${appSettings.masters_db} .sku_codes sku 
          LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id 
          LEFT JOIN ${appSettings.masters_db} .food_types f ON f.food_type_id = sku.food_type_id
          WHERE short_code = ${req.product}`
          const getSoakstyle = await manager.query(getSoakStyleQry)
  
          const prodInv : ProductionInventory[] = []
  
          if(getSoakstyle[0].soakStyle == 'NS'){
            const getprevOper = await transactionManager.getRepository(NonSoakedProductsEntity).find({where:{lotCode: req.batchNumber,product:getSoakstyle[0].product,grade:getSoakstyle[0].grade,year:req.year,plantId:req.plantId}})
            if(getprevOper.length == 0){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'No record found in Non soaked proudcts info')
            }
            let updateIssuedQty
            if(getprevOper[0].operation  == OperationTypeEnum.VALUE_ADDITION){
              if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
              updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.batchNumber,operation:getprevOper[0].operation,inputGrade:String(getprevOper[0].count),subPlantId:req.plantId,year:req.year},{issuedQuantity:req.reportedQty})
              }else{

                updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.batchNumber,operation:getprevOper[0].operation,inputGrade:String(getprevOper[0].count),plantId:req.plantId,subPlantId:0,year:req.year},{issuedQuantity:req.reportedQty})
              }
            }
            else if(getprevOper[0].operation  == OperationTypeEnum.GRADING){
              if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
              updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.batchNumber,operation:getprevOper[0].operation,outputGrade:String(getprevOper[0].count),subPlantId:req.plantId,year:req.year},{issuedQuantity:req.reportedQty})
              }else{
                updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.batchNumber,operation:getprevOper[0].operation,outputGrade:String(getprevOper[0].count),plantId:req.plantId,subPlantId:0,year:req.year},{issuedQuantity:req.reportedQty})
              }
            }
            if(!updateIssuedQty.affected){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in updating issued quantity')
            }
            const prodCookignObj = new ProductionInventory()
            prodCookignObj.lotNumber = req.batchNumber
            prodCookignObj.subLotNumber = req.batchNumber
            prodCookignObj.operation = OperationTypeEnum.COOKING
            prodCookignObj.prevOperation = getprevOper[0].operation
            prodCookignObj.inputGrade = String(req.count)
            prodCookignObj.outputGrade = String(req.count)
            prodCookignObj.plantId = saveProdInv[0].plantId
            prodCookignObj.createdUser = req.createdUser
            prodCookignObj.physicalQuantity = req.reportedQty
            prodCookignObj.issuedQuantity = req.reportedQty
            prodCookignObj.product = getSoakstyle[0].product
            prodCookignObj.subPlantId = saveProdInv[0].subPlantId
            prodCookignObj.year = req.year
            prodCookignObj.processType = req.processType
            prodInv.push(prodCookignObj)
          }
          else{
            let updatedIssuedQtyAtSoaking
            if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
              updatedIssuedQtyAtSoaking = await transactionManager.getRepository(ProductionInventory).update({lotNumber:req.batchNumber,operation:OperationTypeEnum.SOAKING,outputGrade:getSoakstyle[0].grade,subPlantId:req.plantId,year:req.year},{issuedQuantity:req.reportedQty})
            }else{
              updatedIssuedQtyAtSoaking = await transactionManager.getRepository(ProductionInventory).update({lotNumber:req.batchNumber,operation:OperationTypeEnum.SOAKING,outputGrade:getSoakstyle[0].grade,plantId:req.plantId,subPlantId:0,year:req.year},{issuedQuantity:req.reportedQty})
            }
            if(!updatedIssuedQtyAtSoaking.affected){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in updating issued qty')
            }
            const prodCookignObj = new ProductionInventory()
            prodCookignObj.lotNumber = req.batchNumber
            prodCookignObj.subLotNumber = req.batchNumber
            prodCookignObj.operation = OperationTypeEnum.COOKING
            prodCookignObj.prevOperation =OperationTypeEnum.SOAKING
            prodCookignObj.inputGrade = String(req.count)
            prodCookignObj.outputGrade = String(req.count)
            prodCookignObj.plantId = saveProdInv[0].plantId
            prodCookignObj.createdUser = req.createdUser
            prodCookignObj.physicalQuantity = req.reportedQty
            prodCookignObj.issuedQuantity = req.reportedQty
            prodCookignObj.product = getSoakstyle[0].product
            prodCookignObj.subPlantId = saveProdInv[0].subPlantId
            prodCookignObj.year = req.year
            prodCookignObj.processType = req.processType
            prodInv.push(prodCookignObj)
          }
          const prodCookignObj = new ProductionInventory()
          prodCookignObj.lotNumber = req.batchNumber
          prodCookignObj.subLotNumber = req.batchNumber
          prodCookignObj.operation = OperationTypeEnum.VALUE_ADDITION
          prodCookignObj.prevOperation =OperationTypeEnum.COOKING
          prodCookignObj.inputGrade = String(req.count)
          prodCookignObj.outputGrade = String(req.count)
          prodCookignObj.plantId = saveProdInv[0].plantId
          prodCookignObj.createdUser = req.createdUser
          prodCookignObj.physicalQuantity = req.reportedQty
          prodCookignObj.issuedQuantity = req.reportedQty
          prodCookignObj.product = getSoakstyle[0].product
          prodCookignObj.subPlantId = saveProdInv[0].subPlantId
          prodCookignObj.boxes = req.boxes
          prodCookignObj.year = req.year
          prodCookignObj.processType = req.processType
          prodInv.push(prodCookignObj)
  
          const prodInvSave = await transactionManager.getRepository(ProductionInventory).save(prodInv)
  
          if(prodInvSave){
            for(const rec of prodInvSave){
              
              // Production Log Saving
              // job number generation 
              let today = new Date();
              let CurrentYear = today.getFullYear();
              let CurrentMonth = today.getMonth();
              let fromDate = 0;
              let toDate = 0;
              let totalRecords = await (await transactionManager.getRepository(ProductionLog).find({ where: { operationType: rec.operation } })).length;
      
              if (CurrentMonth < 4) {
                  fromDate = (CurrentYear-1);
                  toDate = (CurrentYear);
              } else {
                  fromDate = (CurrentYear);
                  toDate = (CurrentYear + 1);
              }
      
              totalRecords = totalRecords + 1;
      
              var refNo = totalRecords + "";
              while (refNo.length < 4) refNo = "0" + refNo;
      
              const jobNo = rec.operation + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
      
              const prodLogObj = new ProductionLog()
              prodLogObj.lotNumber = req.batchNumber
              prodLogObj.subLotNumber = req.batchNumber
              prodLogObj.inputGrade = rec.outputGrade
              prodLogObj.operationType = rec.operation
              prodLogObj.jobNumber = jobNo
              prodLogObj.plantId = rec.plantId
              prodLogObj.subPlantId = rec.subPlantId
              prodLogObj.jobStatus = JobCompletedEnum.YES
              prodLogObj.assignCooking = rec.operation == OperationTypeEnum.COOKING ? true : false
              prodLogObj.actualOutputQuantity = req.reportedQty
              prodLogObj.createdUser = req.createdUser
              prodLogObj.assignedUser = req.createdUser
              prodLogObj.prodInvId = rec.productionInventoryId
              prodLogObj.prevOperation = rec.prevOperation
              prodLogObj.inputBoxes = rec.boxes
              prodLogObj.year = req.year
              prodLogObj.processType = req.processType
              if(rec.operation == OperationTypeEnum.VALUE_ADDITION){
                prodLogObj.billNo = req.billNo
                prodLogObj.date = req.date
                prodLogObj.noOfPersons = req.noOfPersons
                prodLogObj.scopeOfWork = req.scopeOfWork
                prodLogObj.averageQty =  Number(req.reportedQty) / Number(req.noOfPersons)
                prodLogObj.unitPrice = req.peelingRate
                prodLogObj.amount = Number(req.peelingRate) * Number(req.noOfPersons)
              }
              const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
              if(!prodLogSave){
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in saving in production log')
              }else{
                productionLogId = prodLogSave.productionLogId
              }
        }
  
      
          }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Somthing went wrong in saving production inventory')
          }
        }
        else if(req.prevOperation == OperationTypeEnum.SOAKING){
          const findRecToUpdateRejectedQtyInfo = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.batchNumber,inputGrade:req.count,product:req.rejectionFrom,plantId:req.plantId,year:req.year,operation:req.prevOperation}})
          if(findRecToUpdateRejectedQtyInfo.length > 0){
            const updateRejectedQty = await transactionManager.getRepository(ProductionInventory).update({productionInventoryId:findRecToUpdateRejectedQtyInfo[0].productionInventoryId},{rejectedQuantity:() => `rejected_quantity + ${req.reportedQty}`,wipQuantity:() => `wip_quantity - ${req.reportedQty}`})
            if(updateRejectedQty.affected){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in updating rejected qty info')
            }
          }
           // job number generation 
           let today = new Date();
           let CurrentYear = today.getFullYear();
           let CurrentMonth = today.getMonth();
           let fromDate = 0;
           let toDate = 0;
           let totalRecords = await (await transactionManager.getRepository(ProductionLog).find({ where: { operationType: req.operation } })).length;
   
           if (CurrentMonth < 4) {
               fromDate = (CurrentYear-1);
               toDate = (CurrentYear);
           } else {
               fromDate = (CurrentYear);
               toDate = (CurrentYear + 1);
           }
   
           totalRecords = totalRecords + 1;
   
           var refNo = totalRecords + "";
           while (refNo.length < 4) refNo = "0" + refNo;
   
           const jobNo = req.operation + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
          const prodLogObj = new ProductionLog()
          prodLogObj.lotNumber = req.batchNumber
              prodLogObj.subLotNumber = req.batchNumber
              prodLogObj.inputGrade = String(req.count)
              prodLogObj.operationType = req.operation
              prodLogObj.jobNumber = jobNo
              prodLogObj.plantId = req.plantId
              prodLogObj.subPlantId = 0 //need to add sub plant logic after
              prodLogObj.jobStatus = JobCompletedEnum.YES
              prodLogObj.assignCooking = req.operation == OperationTypeEnum.COOKING ? true : false
              prodLogObj.inputQuantity = req.reportedQty
              prodLogObj.createdUser = req.createdUser
              prodLogObj.assignedUser = req.createdUser
              prodLogObj.prodInvId = saveProdInv.productionInventoryId
              prodLogObj.prevOperation = req.prevOperation
              prodLogObj.inputBoxes = req.boxes
              prodLogObj.year = req.year
              prodLogObj.actualOutputQuantity = req.outputQuantity
              prodLogObj.workStation = req.workStation
              prodLogObj.shift = req.shift
              prodLogObj.billNo = req.billNo
              prodLogObj.date = req.date
              prodLogObj.noOfPersons = req.noOfPersons
              prodLogObj.scopeOfWork = req.scopeOfWork
              prodLogObj.averageQty =  Number(req.reportedQty) / Number(req.noOfPersons)
              prodLogObj.unitPrice = req.peelingRate
              prodLogObj.amount = req.outputQuantity > 0 ?  Number(req.peelingRate) * Number(req.outputQuantity) : Number(req.peelingRate) * Number(req.reportedQty)
              prodLogObj.peelingPriceBasedOn = req.peelingPriceBasedOn
              prodLogObj.isRRP = req.isRRP
              prodLogObj.rejectionFrom = req.rejectionFrom
              prodLogObj.contractorId = req.contractorId
              prodLogObj.processType = req.processType
              prodLogObj.product = req.product
              const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
              if(!prodLogSave){
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in saving in production log')
              }else{
                productionLogId = prodLogSave.productionLogId
              }
        }
        else if(req.prevOperation == OperationTypeEnum.PACKING){
          let today = new Date();
          let CurrentYear = today.getFullYear();
          let CurrentMonth = today.getMonth();
          let fromDate = 0;
          let toDate = 0;
          let totalRecords = await (await this.logRepository.find({ where: { operationType: req.operation } })).length;
    
    
          if (CurrentMonth < 4) {
            fromDate = (CurrentYear-1);
            toDate = (CurrentYear);
          } else {
            fromDate = (CurrentYear);
            toDate = (CurrentYear + 1);
          }
    
          totalRecords = totalRecords + 1;
    
          var refNo = totalRecords + "";
          while (refNo.length < 4) refNo = "0" + refNo;
          const grnJobNo = 'VALUEADD' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
          console.log(req.batchNumber,"^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^6")
            const prodLogObj = new ProductionLog()
            prodLogObj.lotNumber = req.batchNumber
            prodLogObj.subLotNumber = req.batchNumber
            prodLogObj.operationType = req.operation
            prodLogObj.jobNumber = grnJobNo
            prodLogObj.jobStatus = JobCompletedEnum.NO
            prodLogObj.assignCooking = false
            prodLogObj.inputGrade = String(req.count)
            prodLogObj.inputQuantity = req.reportedQty
            prodLogObj.prodInvId =getPrevRec.length > 0 ? getPrevRec[0].productionInventoryId :  saveProdInv.productionInventoryId
            prodLogObj.plantId = getPrevRec.length > 0 ? getPrevRec[0].plantId : saveProdInv.plantId
            prodLogObj.subPlantId = getPrevRec.length > 0 ? getPrevRec[0].subPlantId : saveProdInv.subPlantId
            prodLogObj.workStation = req.workStation
            prodLogObj.shift = req.shift
            prodLogObj.createdUser = req.createdUser
            prodLogObj.assignedUser = req.createdUser
            prodLogObj.product = req.product
            prodLogObj.prevOperation = req.prevOperation
            prodLogObj.inputBoxes = req.boxes
            prodLogObj.billType = 'Peeling'
            prodLogObj.billNo = req.billNo
            prodLogObj.date = req.date
            prodLogObj.noOfPersons = findPrevBillInfo.length > 0 && findPrevBillInfo[0]?.noOfPersons > 0 ? findPrevBillInfo[0].noOfPersons : req.noOfPersons
            prodLogObj.scopeOfWork = req.scopeOfWork
            prodLogObj.contractorId = req.contractorId
            prodLogObj.actualOutputQuantity= req.outputQuantity
            prodLogObj.peelingPriceBasedOn = req.peelingPriceBasedOn
            // prodLogObj.averageQty =  Number(req.reportedQty) / Number(req.noOfPersons)
            prodLogObj.unitPrice = req.peelingRate
            prodLogObj.amount = req.outputQuantity > 0 ?  Number(req.peelingRate) * Number(req.outputQuantity) : Number(req.peelingRate) * Number(req.reportedQty)
            prodLogObj.year = req.year
            prodLogObj.processType = req.processType
            const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
           
            if(!prodLogSave){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in saving in production log')
            }else{
              productionLogId = prodLogSave.productionLogId
            }
  
        }
  
      }

      if(!(saveFlag.has(false))){
        let workersSaveFalg = new Set<boolean>()
        if(request[0].workersInfo !=undefined){
          for(const rec of request[0].workersInfo){
            const peelingObj = new ProductionWorkersEntity()
            peelingObj.contractorId = rec.contractorId
            peelingObj.contractorName = rec.contractorName
            peelingObj.empCode = rec.workerCode
            peelingObj.empId = rec.workerId
            peelingObj.empName = rec.workerName
            peelingObj.village = rec.village
            peelingObj.productionLogId = productionLogId
            peelingObj.transportation = rec.transportation
            peelingObj.billNo = request[0].billNo
            peelingObj.transportCharges = rec.transportation == 'Auto' ? rec.transportCost  : 0
            peelingObj.operation = OperationTypeEnum.PEELING
            peelingObj.avgQty = request[0].avgQty
            peelingObj.avgWage = request[0].avgWage
            const peelingWorkersInfoSave = await transactionManager.getRepository(ProductionWorkersEntity).save(peelingObj)
            if(peelingWorkersInfoSave){
              workersSaveFalg.add(true) 
            }else{
              workersSaveFalg.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in saving peeling workers info')
            }
          }
        }
        if(!(workersSaveFalg.has(false))){
          await transactionManager.completeTransaction()
          return new CommonResponse(true,1,'Saved successfully')
        }
        else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving peeling workers info')
        }
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong')
      }
    }catch(err){
      console.log(err,'===')
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong',err)
    }
  }

  async getProductsAgainstValAdd():Promise<CommonResponse>{
    try{
      const manager = getManager()
      const infoQuery = `SELECT product from ${appSettings.production_db} .production_inventory group by product`
      const info = await manager.query(infoQuery)
      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }

    }catch(err){
      throw err
    }
  }

  async createSoakingReporting(req:OperationReportingReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    try{
      await transactionManager.startTransaction()

      const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(req.plantId))


      if(req.prevOperation != OperationTypeEnum.PACKING){
        let getQtyAtPrevOperation
        if(req.prevOperation == OperationTypeEnum.VALUE_ADDITION){
          if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.VALUE_ADDITION,lotNumber:req.batchNumber,inputGrade:req.count,subPlantId:req.plantId,product:req.prevOperProduct, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
          }else{
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.VALUE_ADDITION,lotNumber:req.batchNumber,inputGrade:req.count,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year }),product:req.prevOperProduct}})
          }
        }else{
          if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.GRADING,lotNumber:req.batchNumber,outputGrade:req.count,subPlantId:req.plantId, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year }),product:req.prevOperProduct}})
          }else{
            getQtyAtPrevOperation = await transactionManager.getRepository(ProductionInventory).find({where:{operation:OperationTypeEnum.GRADING,lotNumber:req.batchNumber,outputGrade:req.count,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year }),product:req.prevOperProduct}})
          }
        }
        // const operation = req.prevOperation == OperationTypeEnum.VALUE_ADDITION ? OperationTypeEnum.VALUE_ADDITION  : OperationTypeEnum.GRADING
        // let gradedQty = req.prevOperation == OperationTypeEnum.VALUE_ADDITION ? getQtyAtPrevOperation[0].wipQuantity : getQtyAtPrevOperation[0].physicalQuantity
        // if(Number(req.reportedQty) > Number(gradedQty)){
        //   await transactionManager.releaseTransaction()
        //   return new CommonResponse(false,0,'Issued quantity sholud be less than available HL quantity')
        // }
      }


      let getprevOpeInfo
      if(req.prevOperation == OperationTypeEnum.GRADING){
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
        getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,outputGrade:req.count,subLotNumber:req.batchNumber,subPlantId:req.plantId, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }else{
          getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,outputGrade:req.count,subLotNumber:req.batchNumber,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }
      }else if(req.prevOperation == OperationTypeEnum.VALUE_ADDITION){
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
          getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,subLotNumber:req.batchNumber,subPlantId:req.plantId, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year }),product:req.prevOperProduct}})
          }else{
            getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,subLotNumber:req.batchNumber,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year }),product:req.prevOperProduct}})
          }
      }else{
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
        getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,subLotNumber:req.batchNumber,subPlantId:req.plantId, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }else{
          getprevOpeInfo = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.prevOperation,inputGrade:req.count,subLotNumber:req.batchNumber,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }
      }

      if(getprevOpeInfo.length > 0 || req.prevOperation == OperationTypeEnum.PACKING){
        let operExistCheck
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
        operExistCheck = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.operation,inputGrade:req.count,outputGrade:req.grade,subLotNumber:req.batchNumber,prevOperation:req.prevOperation,product:req.product,subPlantId:req.plantId, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }else{
          operExistCheck = await transactionManager.getRepository(ProductionInventory).find({where:{operation:req.operation,inputGrade:req.count,outputGrade:req.grade,subLotNumber:req.batchNumber,prevOperation:req.prevOperation,product:req.product,plantId:req.plantId,subPlantId:0, ...(req.processType !== ProductionProcessTypeEnum.REPROCESS && { year: req.year })}})
        }
        const prodInvObj = new ProductionInventory()
        if(result.data.plantType == UnitTypeEnum.PLANT){
          prodInvObj.subPlantId = 0
          prodInvObj.plantId = req.plantId;
        }
        if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
            prodInvObj.subPlantId = req.plantId;
            prodInvObj.plantId = operExistCheck[0].plantId;
  
        }
        if(operExistCheck.length > 0){
          prodInvObj.productionInventoryId = operExistCheck[0].productionInventoryId
          prodInvObj.updatedUser = req.createdUser
          prodInvObj.wipQuantity = Number(req.reportedQty) + Number(operExistCheck[0].wipQuantity)
        }else{
          prodInvObj.lotNumber = req.batchNumber
          prodInvObj.subLotNumber = req.batchNumber
          prodInvObj.inputGrade = String(req.count)
          prodInvObj.operation = req.operation
          prodInvObj.outputGrade = req.grade
          prodInvObj.prevOperation = req.prevOperation
          prodInvObj.product = req.product
          prodInvObj.createdUser = req.createdUser
          prodInvObj.wipQuantity = req.reportedQty
          prodInvObj.year = req.year
          prodInvObj.processType = req.processType
        }
        const prodInvSave = await transactionManager.getRepository(ProductionInventory).save(prodInvObj)
        if(prodInvSave){
            // job number generation 
              let today = new Date();
              let CurrentYear = today.getFullYear();
              let CurrentMonth = today.getMonth();
              let fromDate = 0;
              let toDate = 0;
              let totalRecords = await (await this.logRepository.find({ where: { operationType: req.operation } })).length;


              if (CurrentMonth < 4) {
                fromDate = (CurrentYear-1);
                toDate = (CurrentYear);
              } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
              }

              totalRecords = totalRecords + 1;

              var refNo = totalRecords + "";
              while (refNo.length < 4) refNo = "0" + refNo;
              const grnJobNo = 'SOAKING' + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

          const prodLogObj = new ProductionLog()
          prodLogObj.jobNumber = grnJobNo
          prodLogObj.inputGrade = String(req.count)
          prodLogObj.actualGrade = String(req.grade)
          prodLogObj.assignedUser = req.createdUser
          prodLogObj.createdUser = req.createdUser
          prodLogObj.inputQuantity = req.reportedQty
          prodLogObj.lotNumber = req.batchNumber
          prodLogObj.operationType = req.operation
          prodLogObj.plantId = prodInvSave.plantId
          prodLogObj.subPlantId = prodInvSave.subPlantId
          prodLogObj.prodInvId = prodInvSave.productionInventoryId 
          prodLogObj.product = req.product
          prodLogObj.shift = req.shift
          prodLogObj.subLotNumber = req.batchNumber
          prodLogObj.workStation = req.workStation
          prodLogObj.workStationType = WorkStationTypeEnum.INTERNAL
          prodLogObj.prevOperation = req.prevOperation
          prodLogObj.soakingTime = String(req.soakTime)
          prodLogObj.soakingStyle = req.soakStyle
          prodLogObj.date = req.date
          prodLogObj.year = req.year
          prodLogObj.processType = req.processType

          const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
          if(prodLogSave){
            if(req.prevOperation != OperationTypeEnum.PACKING){
              let updateIssuedQty
              if(req.prevOperation == OperationTypeEnum.VALUE_ADDITION){
                updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({productionInventoryId:getprevOpeInfo[0].productionInventoryId},{issuedQuantity:Number(getprevOpeInfo[0].issuedQuantity) + Number(req.reportedQty),physicalQuantity: Number(getprevOpeInfo[0].physicalQuantity) + Number(req.reportedQty),wipQuantity:Number(getprevOpeInfo[0].wipQuantity) - Number(req.reportedQty)})
              }else{
                updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({productionInventoryId:getprevOpeInfo[0].productionInventoryId},{issuedQuantity:Number(getprevOpeInfo[0].issuedQuantity) + Number(req.reportedQty),physicalQuantity: Number(getprevOpeInfo[0].physicalQuantity) + Number(req.reportedQty)})
              }
              if(!updateIssuedQty.affected){
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Soemthing went wrong in updating issued qty')
              }
            }
            await transactionManager.completeTransaction()
            return new CommonResponse(true,1,'Saved successfully')
          }else{
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in Prodcution Log Saving')
          }
        }

      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Previous Operation record not found with the given count and batch number')
      }
    }catch(err){
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong',err)
    }
  }

  async createNonSoakedProductsInfo(req:OperationReportingReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager()
    try{
      await transactionManager.startTransaction()
      const productObj = new NonSoakedProductsEntity()
      productObj.lotCode = req.batchNumber
      productObj.count = req.count
      productObj.grade = req.grade
      productObj.product  = req.product
      productObj.operation = req.prevOperation
      productObj.createdUser = req.createdUser
      productObj.plantId = req.plantId
      productObj.year = req.year
      productObj.fromproduct = req.prevOperProduct

      const save = await transactionManager.getRepository(NonSoakedProductsEntity).save(productObj)
      if(save){
        await transactionManager.completeTransaction()
        return new CommonResponse(true,1,'Saved successfully')
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong')
      }
    }catch(err){
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong')
    }
  }

  async createStockInInfo(req:PackingInfoReq):Promise<CommonResponse>{
    // const manager = getManager()
    const transactionManager = new GenericTransactionManager()
    try{
      await transactionManager.startTransaction()
      let saveFlag = new Set<boolean>()
      let quantity
      // const productInfoQry = `SELECT varient_id variantId,no_of_pouches AS pouches,pouches_per_row AS pouchWeight,uom.uom_name as uom
      // FROM ${appSettings.sales_db} .sale_order_items soi
      // LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON soi.pack_style_id = pm.packing_method_id 
      // LEFT JOIN  ${appSettings.masters_db} . uoms uom ON uom.uom_id = pm.uom_id
      // WHERE sale_order_item_id = ${req.saleOrderItemId}`
      const productInfo = await this.inventoryRepository.getProdcutsInfoForStockInEntry(req.saleOrderItemId)
      const totalPouches =( Number(req.cartons) * Number(productInfo[0].pouches)) + Number(req.loosePouches)
      if(productInfo[0].uom == 'KGS'){
        quantity = totalPouches * Number(productInfo[0].pouchWeight)
      }else if(productInfo[0].uom == 'LBS'){
          const qtyInLbs = totalPouches * Number(productInfo[0].pouchWeight)
          quantity = Number(qtyInLbs) * 0.454
      } else if(productInfo[0].uom == 'GMS'){
          const gmtokg = Number(productInfo[0].pouchWeight) / 1000
          quantity = totalPouches * Number(gmtokg)
      } else if(productInfo[0].uom == 'OZ'){
          const oztolb = Number(productInfo[0].pouchWeight) / 16
          const qtyInLbs = totalPouches * Number(oztolb)
          quantity = Number(qtyInLbs) * 0.454
      }

      
      if(req.transactionType == TransactionType.repacking || req.transactionType == TransactionType.rework){
        const prodInv = new ProductionInventory()
        prodInv.lotNumber = req.lotNumber
        prodInv.subLotNumber = req.lotNumber
        prodInv.operation = OperationTypeEnum.PACKING
        prodInv.prevOperation = OperationTypeEnum.PACKING
        prodInv.inputGrade = productInfo[0].grade
        prodInv.outputGrade =  productInfo[0].grade
        prodInv.plantId = req.plantId
        prodInv.createdUser = req.createdUser
        prodInv.physicalQuantity = quantity
        prodInv.issuedQuantity = quantity
        prodInv.year = req.year
        prodInv.product = productInfo[0].shortCode
        const prodSave = await transactionManager.getRepository(ProductionInventory).save(prodInv)

        if(prodSave){
          let today = new Date();
          let CurrentYear = today.getFullYear();
          let CurrentMonth = today.getMonth();
          let fromDate = 0;
          let toDate = 0;
          let totalRecords = await (await transactionManager.getRepository(ProductionLog).find({ where: { operationType: OperationTypeEnum.PACKING } })).length;
  
          if (CurrentMonth < 4) {
              fromDate = (CurrentYear-1);
              toDate = (CurrentYear);
          } else {
              fromDate = (CurrentYear);
              toDate = (CurrentYear + 1);
          }
  
          totalRecords = totalRecords + 1;
  
          var refNo = totalRecords + "";
          while (refNo.length < 4) refNo = "0" + refNo;
  
          const jobNo = OperationTypeEnum.PACKING + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
          const prodLogObj = new ProductionLog()
          prodLogObj.lotNumber = req.lotNumber
          prodLogObj.subLotNumber = req.lotNumber
          prodLogObj.inputGrade = productInfo[0].grade
          prodLogObj.operationType = OperationTypeEnum.PACKING
          prodLogObj.jobNumber = jobNo
          prodLogObj.plantId = req.plantId
          prodLogObj.jobStatus = JobCompletedEnum.YES
          prodLogObj.assignCooking = false
          prodLogObj.actualOutputQuantity = quantity
          prodLogObj.createdUser = req.createdUser
          prodLogObj.assignedUser = req.createdUser
          prodLogObj.prodInvId = prodSave.productionInventoryId
          prodLogObj.prevOperation = OperationTypeEnum.PACKING
          prodLogObj.year = req.year
          prodLogObj.product = productInfo[0].shortCode
          prodLogObj.date = req.stockInDate
          prodLogObj.reportingLogId = req.reportingLogId
          if(req.transactionType == TransactionType.repacking){
            prodLogObj.processType = ProductionProcessTypeEnum.REPACKING
          }
          if(req.transactionType == TransactionType.rework){
            prodLogObj.processType = ProductionProcessTypeEnum.REWORK
          }
          // if(req.transactionType == )
          const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
          if(!prodLogSave){
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in saving in production log')
          }
        }else{
          await transactionManager.releaseTransaction()
          return new CommonResponse(false,0,'Something went wrong in saving production inventory')
        }
      }
      else{
        // const getSoakStyleQry = `SELECT soaking_style as soakStyle,grade_name as grade, short_code as product,f.food_type as foodType FROM ${appSettings.masters_db} .sku_codes sku 
        // LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id 
        // LEFT JOIN ${appSettings.masters_db} .food_types f ON f.food_type_id = sku.food_type_id
        // WHERE sku_code_id = ${productInfo[0].variantId}`
        // const getSoakstyle = await manager.query(getSoakStyleQry)
  
        const getSoakstyle = await this.inventoryRepository.getSoakStyleInfoForStockInEntry(productInfo[0].variantId)

        let gradeInfoAgainstProduct
        if(req.gradeChange){
          gradeInfoAgainstProduct = await this.inventoryRepository.getGradeAgainstProduct(req.soakingOutproduct)
        }
  
        if(getSoakstyle[0].soakStyle == 'NS' && req.rejectionFrom == undefined){
          const getprevOper = await transactionManager.getRepository(NonSoakedProductsEntity).find({where:{lotCode: req.lotNumber,product:req.gradeChange ? req.soakingOutproduct : getSoakstyle[0].product,grade:req.gradeChange ? gradeInfoAgainstProduct[0].grade : getSoakstyle[0].grade,plantId:req.plantId,...(req.transactionType !== "reprocessing" && { year: req.year })}})
  
          if(getprevOper.length == 0){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'No record found in Non soaked proudcts info')
          }
          let updateIssuedQty
          if(getprevOper[0].operation  == OperationTypeEnum.VALUE_ADDITION){
            // getPrevRec = await transactionManager.getRepository(ProductionInventory).find({where:{subLotNumber:req.lotNumber,operation:getprevOper[0].operation,inputGrade:getprevOper[0].count}})
            updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.lotNumber,operation:getprevOper[0].operation,inputGrade:String(getprevOper[0].count),plantId:req.plantId,...(req.transactionType !== "reprocessing" && { year: req.year })},{issuedQuantity:() => `issued_quantity + ${quantity}`,wipQuantity: () => `wip_quantity - ${quantity}`,physicalQuantity:() => `physical_quantity + ${quantity}`})
          }else if(getprevOper[0].operation  == OperationTypeEnum.GRADING){
            // getPrevRec = await transactionManager.getRepository(ProductionInventory).find({where:{subLotNumber:req.lotNumber,operation:getprevOper[0].operation,outputGrade:getprevOper[0].count}})
            updateIssuedQty = await transactionManager.getRepository(ProductionInventory).update({subLotNumber:req.lotNumber,operation:getprevOper[0].operation,outputGrade:String(getprevOper[0].count),plantId:req.plantId,...(req.transactionType !== "reprocessing" && { year: req.year })},{issuedQuantity: () => `issued_quantity + ${quantity}`})
          }
          if(!updateIssuedQty.affected){
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in updating issued quantity')
          }
  
          const prodInv : ProductionInventory[] = []
          if(getSoakstyle[0].foodType != 'RAW'){
            const findprevCookingRec = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.lotNumber,operation:OperationTypeEnum.COOKING,prevOperation:getprevOper[0].operation,inputGrade:getSoakstyle[0].grade,plantId:req.plantId,product:getSoakstyle[0].product,...(req.transactionType !== "reprocessing" && { year: req.year })}})
            const prodCookignObj = new ProductionInventory()
            prodCookignObj.lotNumber = req.lotNumber
            prodCookignObj.subLotNumber = req.lotNumber
            prodCookignObj.operation = OperationTypeEnum.COOKING
            prodCookignObj.prevOperation = getprevOper[0].operation
            prodCookignObj.inputGrade = getSoakstyle[0].grade
            prodCookignObj.outputGrade = getSoakstyle[0].grade
            prodCookignObj.plantId = req.plantId
            prodCookignObj.createdUser = req.createdUser
            prodCookignObj.product = getSoakstyle[0].product
            prodCookignObj.year = req.year
            if(findprevCookingRec.length > 0){
              prodCookignObj.productionInventoryId = findprevCookingRec[0].productionInventoryId
              prodCookignObj.physicalQuantity = Number(findprevCookingRec[0].physicalQuantity) + Number(quantity)
              prodCookignObj.issuedQuantity = Number(findprevCookingRec[0].issuedQuantity) + Number(quantity)
            }else{
              prodCookignObj.physicalQuantity = quantity
              prodCookignObj.issuedQuantity = quantity
            }
            prodInv.push(prodCookignObj)
          }
          const findprevPackingRec = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.lotNumber,operation:OperationTypeEnum.PACKING,prevOperation:getSoakstyle[0].foodType == 'RAW' ?  getprevOper[0].operation : OperationTypeEnum.COOKING,inputGrade:getSoakstyle[0].grade,plantId:req.plantId,product:getSoakstyle[0].product,...(req.transactionType !== "reprocessing" && { year: req.year })}})
          const prodObj = new ProductionInventory()
          prodObj.lotNumber = req.lotNumber
          prodObj.subLotNumber = req.lotNumber
          prodObj.operation = OperationTypeEnum.PACKING
          prodObj.prevOperation = getSoakstyle[0].foodType == 'RAW' ?  getprevOper[0].operation : OperationTypeEnum.COOKING
          prodObj.inputGrade = getSoakstyle[0].grade
          prodObj.outputGrade = getSoakstyle[0].grade
          prodObj.plantId = req.plantId
          prodObj.createdUser = req.createdUser
          prodObj.product = getSoakstyle[0].product
          prodObj.year = req.year
          if(findprevPackingRec.length > 0){
            prodObj.productionInventoryId = findprevPackingRec[0].productionInventoryId
            prodObj.physicalQuantity = Number(findprevPackingRec[0].physicalQuantity) + Number(quantity)
          }else{
            prodObj.physicalQuantity = quantity
          }
          prodInv.push(prodObj)
  
          const prodInvSave = await transactionManager.getRepository(ProductionInventory).save(prodInv)
  
          if(prodInvSave){
            saveFlag.add(true)
  
            for(const rec of prodInvSave){
              
              // Production Log Saving
              // job number generation 
              let today = new Date();
              let CurrentYear = today.getFullYear();
              let CurrentMonth = today.getMonth();
              let fromDate = 0;
              let toDate = 0;
              let totalRecords = await (await transactionManager.getRepository(ProductionLog).find({ where: { operationType: rec.operation } })).length;
      
              if (CurrentMonth < 4) {
                  fromDate = (CurrentYear-1);
                  toDate = (CurrentYear);
              } else {
                  fromDate = (CurrentYear);
                  toDate = (CurrentYear + 1);
              }
      
              totalRecords = totalRecords + 1;
      
              var refNo = totalRecords + "";
              while (refNo.length < 4) refNo = "0" + refNo;
      
              const jobNo = rec.operation + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
      
              const prodLogObj = new ProductionLog()
              prodLogObj.lotNumber = req.lotNumber
              prodLogObj.subLotNumber = req.lotNumber
              prodLogObj.inputGrade = rec.outputGrade
              prodLogObj.operationType = rec.operation
              prodLogObj.jobNumber = jobNo
              prodLogObj.plantId = req.plantId
              prodLogObj.jobStatus = JobCompletedEnum.YES
              prodLogObj.assignCooking = rec.operation == OperationTypeEnum.COOKING ? true : false
              prodLogObj.actualOutputQuantity = quantity
              prodLogObj.createdUser = req.createdUser
              prodLogObj.assignedUser = req.createdUser
              prodLogObj.prodInvId = rec.productionInventoryId
              prodLogObj.prevOperation = rec.prevOperation
              prodLogObj.year = req.year
              prodLogObj.product = rec.product
              if(rec.operation == OperationTypeEnum.PACKING){
                prodLogObj.gradeChange = req.gradeChange
                prodLogObj.soakingoutProduct = req.soakingOutproduct
                prodLogObj.date=req.stockInDate
                prodLogObj.reportingLogId = req.reportingLogId

              }
              if(req.transactionType == TransactionType.rm){
                prodLogObj.processType = ProductionProcessTypeEnum.FRESHPRODUCITON
              }
              if(req.transactionType == TransactionType.reprocessing){
                prodLogObj.processType = ProductionProcessTypeEnum.REPROCESS
              }
              const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
              if(!prodLogSave){
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in saving in production log')
              }
            }
          }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Somethig went wrong in saving prodcution inventory')
          }
  
        }else{

          if(req.rejectionFrom != undefined){
            let findProdLogInfo
            let findNonSoakedProduct
            if(req.productCategory == ProductCategoryEnum.RRP){
              findProdLogInfo = await transactionManager.getRepository(ProductionLog).find({where:{rejectionFrom:req.rejectionFrom,lotNumber:req.lotNumber,...(req.transactionType !== "reprocessing" && { year: req.year }),plantId:req.plantId}})
            }else{
              findProdLogInfo = await transactionManager.getRepository(ProductionLog).find({where:{product:req.rejectionFrom,lotNumber:req.lotNumber,...(req.transactionType !== "reprocessing" && { year: req.year }),plantId:req.plantId,operationType:OperationTypeEnum.SOAKING}})

              findNonSoakedProduct = await transactionManager.getRepository(NonSoakedProductsEntity).find({where:{product:req.rejectionFrom,plantId:req.plantId,lotCode:req.lotNumber,...(req.transactionType !== "reprocessing" && { year: req.year })}})

            }

            if(findProdLogInfo.length > 0){
              const updateQtyInProdInv = await transactionManager.getRepository(ProductionInventory).update({productionInventoryId:findProdLogInfo[0].prodInvId},{issuedQuantity: () => `issued_quantity + ${quantity}`,wipQuantity: () => `wip_quantity - ${quantity}`,physicalQuantity: () => `physical_quantity + ${quantity}`})
              if(updateQtyInProdInv.affected){
                saveFlag.add(true)
              }else{
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in updating issued quantity in VA')
              }
            }else if(findNonSoakedProduct.length > 0){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Production Log Info not found')
            }
          }else{
            const updateIssuedQty  = await transactionManager.getRepository(ProductionInventory).update({operation:OperationTypeEnum.SOAKING,outputGrade:req.gradeChange ? gradeInfoAgainstProduct[0].grade : getSoakstyle[0].grade,subLotNumber:req.lotNumber,plantId:req.plantId,product:req.gradeChange ? req.soakingOutproduct : getSoakstyle[0].product, ...(req.transactionType !== "reprocessing" && { year: req.year })},{issuedQuantity: () => `issued_quantity + ${quantity}`,wipQuantity: () => `wip_quantity - ${quantity}`,physicalQuantity: () => `physical_quantity + ${quantity}`})
            if(!updateIssuedQty.affected){
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
              return new CommonResponse(false,0,'Something went wrong in updating issued quantity')
            }
          }
          const prodInv : ProductionInventory[] = []
          if(getSoakstyle[0].foodType != 'RAW'){
            const findprevCookingRec = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.lotNumber,operation:OperationTypeEnum.COOKING,prevOperation:OperationTypeEnum.SOAKING,inputGrade:getSoakstyle[0].grade,plantId:req.plantId,product:getSoakstyle[0].product,...(req.transactionType !== "reprocessing" && { year: req.year })}})
            const prodCookignObj = new ProductionInventory()
            prodCookignObj.lotNumber = req.lotNumber
            prodCookignObj.subLotNumber = req.lotNumber
            prodCookignObj.operation = OperationTypeEnum.COOKING
            prodCookignObj.prevOperation = OperationTypeEnum.SOAKING
            prodCookignObj.inputGrade = getSoakstyle[0].grade
            prodCookignObj.outputGrade = getSoakstyle[0].grade
            prodCookignObj.plantId = req.plantId
            prodCookignObj.createdUser = req.createdUser
            prodCookignObj.product = getSoakstyle[0].product
            prodCookignObj.year = req.year
            if(findprevCookingRec.length > 0){
              prodCookignObj.productionInventoryId = findprevCookingRec[0].productionInventoryId
              prodCookignObj.physicalQuantity = Number(findprevCookingRec[0].physicalQuantity) + Number(quantity)
              prodCookignObj.issuedQuantity = Number(findprevCookingRec[0].issuedQuantity) + Number(quantity)
            }else{
              prodCookignObj.physicalQuantity = quantity
              prodCookignObj.issuedQuantity = quantity
            }
            prodInv.push(prodCookignObj)
          }
          const findprevPackingRec = await transactionManager.getRepository(ProductionInventory).find({where:{lotNumber:req.lotNumber,operation:OperationTypeEnum.PACKING,prevOperation:getSoakstyle[0].foodType == 'RAW' ?  OperationTypeEnum.SOAKING : OperationTypeEnum.COOKING,inputGrade:getSoakstyle[0].grade,plantId:req.plantId,product:getSoakstyle[0].product,...(req.transactionType !== "reprocessing" && { year: req.year }),isRRP:req.rejectionFrom != undefined ? true : false}})
          const prodObj = new ProductionInventory()
          prodObj.lotNumber = req.lotNumber
          prodObj.subLotNumber = req.lotNumber
          prodObj.operation = OperationTypeEnum.PACKING
          prodObj.prevOperation = getSoakstyle[0].foodType == 'RAW' ?  OperationTypeEnum.SOAKING : OperationTypeEnum.COOKING
          prodObj.inputGrade = getSoakstyle[0].grade
          prodObj.outputGrade = getSoakstyle[0].grade
          prodObj.plantId = req.plantId
          prodObj.createdUser = req.createdUser
          prodObj.product = getSoakstyle[0].product
          prodObj.year = req.year
          prodObj.isRRP = req.rejectionFrom != undefined ? true : false
          if(findprevPackingRec.length > 0){
            prodObj.productionInventoryId = findprevPackingRec[0].productionInventoryId
            prodObj.physicalQuantity = Number(findprevPackingRec[0].physicalQuantity) + Number(quantity)
          }else{
            prodObj.physicalQuantity = quantity
          }
          prodInv.push(prodObj)
  
          const prodInvSave = await transactionManager.getRepository(ProductionInventory).save(prodInv)
  
          if(prodInvSave){
            saveFlag.add(true)
  
            for(const rec of prodInvSave){
              
              // Production Log Saving
              // job number generation 
              let today = new Date();
              let CurrentYear = today.getFullYear();
              let CurrentMonth = today.getMonth();
              let fromDate = 0;
              let toDate = 0;
              let totalRecords = await (await transactionManager.getRepository(ProductionLog).find({ where: { operationType: rec.operation } })).length;
      
              if (CurrentMonth < 4) {
                  fromDate = (CurrentYear-1);
                  toDate = (CurrentYear);
              } else {
                  fromDate = (CurrentYear);
                  toDate = (CurrentYear + 1);
              }
      
              totalRecords = totalRecords + 1;
      
              var refNo = totalRecords + "";
              while (refNo.length < 4) refNo = "0" + refNo;
      
              const jobNo = rec.operation + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
              const prodLogObj = new ProductionLog()
              prodLogObj.lotNumber = req.lotNumber
              prodLogObj.subLotNumber = req.lotNumber
              prodLogObj.inputGrade = rec.outputGrade
              prodLogObj.operationType = rec.operation
              prodLogObj.jobNumber = jobNo
              prodLogObj.plantId = req.plantId
              prodLogObj.jobStatus = JobCompletedEnum.YES
              prodLogObj.assignCooking = rec.operation == OperationTypeEnum.COOKING ? true : false
              prodLogObj.actualOutputQuantity = quantity
              prodLogObj.createdUser = req.createdUser
              prodLogObj.assignedUser = req.createdUser
              prodLogObj.prevOperation = rec.prevOperation
              prodLogObj.year = req.year
              prodLogObj.product = rec.product
              prodLogObj.isRRP = req.rejectionFrom != undefined ? true : false
              prodLogObj.rejectionFrom = req.rejectionFrom
              if(rec.operation == OperationTypeEnum.PACKING){
                prodLogObj.gradeChange = req.gradeChange
                prodLogObj.soakingoutProduct = req.soakingOutproduct
                prodLogObj.date = req.stockInDate
                prodLogObj.reportingLogId = req.reportingLogId

              }
              if(req.transactionType == TransactionType.rm){
                prodLogObj.processType = ProductionProcessTypeEnum.FRESHPRODUCITON
              }
              if(req.transactionType == TransactionType.reprocessing){
                prodLogObj.processType = ProductionProcessTypeEnum.REPROCESS
              }
              const prodLogSave = await transactionManager.getRepository(ProductionLog).save(prodLogObj)
              if(prodLogSave.productionLogId == undefined){
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in saving in production log')
            }
            }
          }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in saving prodcution inventory')
          }
  
        }
      }

      if(!(saveFlag.has(false))){
        await transactionManager.completeTransaction()
        return new CommonResponse(true,1,'Updated succesfully')
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'Something went wrong')
      }
    }catch(err){
      console.log(err,'===')
      await transactionManager.releaseTransaction()
      return new CommonResponse(false,0,'Something went wrong')
    }
  }


  async getSoackingData(req:ReportRequest): Promise<CommonResponse> {
    const data = await this.inventoryRepository.getSoakingData(req)
    if (data.length > 0)
      return new CommonResponse(true, 1, 'data retrived', data)
    else
      return new CommonResponse(false, 0, 'No data found');
  }

  async getContractAgainstDeheadingRate(req:OperationReportingReq):Promise<CommonResponse>{
    const queryManager = getManager()
    try{
      const getCustomerCountTypeQry = `SELECT rate FROM ${appSettings.masters_db} .deheading_rates WHERE contractor_id = ${req.contractorId}`
      const contractorInfo = await queryManager.query(getCustomerCountTypeQry)
      let contractorRateInfo
      if(contractorInfo.length > 1){
        const customerRateQry = `SELECT rate FROM ${appSettings.masters_db} .deheading_rates WHERE contractor_id = ${req.contractorId} AND ${req.count} >= min_count AND ${req.count} <= max_count`
        contractorRateInfo = await queryManager.query(customerRateQry)
      }

      if(contractorInfo.length >0){
        return(new CommonResponse(true,1,'Data retrieved',contractorInfo.length > 1 ? contractorRateInfo : contractorInfo))
      }else{
        return new CommonResponse(false,0,'No data found',[])
      }

    }catch(err){
      throw err
    }
  }

  async getCountsAgainstBatchNumber(req:LotAndOperationReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getCountsQry = `SELECT DISTINCT(IF(operation = '${OperationTypeEnum.GRADING}' , output_grade,input_grade)) AS count FROM ${appSettings.production_db} .production_inventory WHERE lot_number = '${req.lotNumber}' AND year = ${req.year} AND operation = '${req.operation}' AND (input_grade IS NOT NULL OR output_grade IS NOT NULL)
       GROUP BY output_grade,input_grade`
      const countsInfo = await manager.query(getCountsQry)
      if(countsInfo.length > 0){
        return new CommonResponse(true,1,'Data retreievd',countsInfo)
      }else{
        return new CommonResponse(false,0,'No data found',[])
      }
    }catch(err){
      throw err
    }
  }

  async getQtyAgainstBatchAndCount(req:LotAndOperationReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQtyQry =  `SELECT IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',wip_quantity,physical_quantity) as qty,
      (physical_quantity - issued_quantity)  as remainingQty,
      IF(operation = 'VALUE ADDITION' OR operation = 'DEHEADING',(physical_quantity-issued_quantity),0) AS availableQty,
      IF(operation = 'DEHEADING',physical_quantity,0) AS honQty FROM ${appSettings.production_db} .production_inventory WHERE lot_number = '${req.lotNumber}' AND year=${req.year} AND operation = '${req.operation}' AND IF(operation = '${OperationTypeEnum.GRADING}',output_grade = ${req.count},input_grade = ${req.count}) AND plant_id = ${req.plantId}`
      if(req.product != undefined){
        getQtyQry += ` AND product = '${req.product}'`
      }

      const qtyInfo = await manager.query(getQtyQry)
      if(qtyInfo.length > 0){
        return new CommonResponse(true,1,'Data retreievd',qtyInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }

    }catch(err){
      throw err
    }
  }


  async getTransportationChargesForReport(req?: TransportChargesReq): Promise<CommonResponse> {
    try {
      const manager = getManager();
      
      // Start building the query without any filters
      let query = `
        select pw.village,wo.village_from_id, pw.contractor_id, pw.transportation, 
        DATE_FORMAT(pl.date, '%d') as day, MONTHNAME(pl.date) as month, 
        vtc.transport_cost as cost, COUNT(DISTINCT pw.emp_name) AS count 
        from erpx_dev_production.production_workers pw
        left join erpx_dev_production.production_log pl on pl.production_log_id = pw.production_log_id
        left join erpx_dev_masters.village_transport_cost vtc on vtc.village_name = pw.village
        left join erpx_dev_masters.workers wo on wo.village_from = pw.village
        where pw.transportation = 'Auto'
      `;
  
      // Add contractorId filter if provided
      if (req?.contractorId) {
        query += ` AND pw.contractor_id = '${req.contractorId}'`;
      }
  
      // Add date range filter if both fromDate and toDate are provided
      if (req?.fromDate && req?.toDate) {
        query += ` AND pl.date BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
      if (req?.villageId) {
        query += ` AND wo.village_from_id = '${req.villageId}'`;
      }
  
      query += ` GROUP BY pw.village, pl.date ORDER BY pl.date`;
  
      // Execute the query
      const result = await manager.query(query);
  
      if (result.length > 0) {
        // Process the result as before to group by village and date
        const villageData = result.reduce((acc, row) => {
          const { village, day, month, count, cost } = row;
  
          // Initialize village entry if not existing
          if (!acc[village]) {
            acc[village] = {
              village,
              monthinfo: month,
              days: {},
              cost // Store the cost for the village
            };
          }
  
          // Store the count for the specific day
          acc[village].days[day] = count;
  
          return acc;
        }, {});
  
        // Now fill in the missing days with 0 counts
        const formattedResult = Object.keys(villageData).map(village => {
          const villageInfo = villageData[village];
          const month = villageInfo.monthinfo;
  
          // Get the number of days in the given month
          const monthYear = result.find(row => row.village === village)?.month || ''; 
          const currentYear = new Date().getFullYear();
          const monthIndex = new Date(`${monthYear} 1, ${currentYear}`).getMonth(); // Convert month name to index
          const daysInMonth = getDaysInMonth(new Date(currentYear, monthIndex)); // Number of days in the month
  
          // Fill missing days with 0
          for (let day = 1; day <= daysInMonth; day++) {
            const dayStr = day < 10 ? `0${day}` : `${day}`; // Format day to two digits
            if (!villageInfo.days[dayStr]) {
              villageInfo.days[dayStr] = "0"; // Set missing days count to 0
            }
          }
  
          return {
            village: villageInfo.village,
            monthinfo: villageInfo.monthinfo,
            days: villageInfo.days,
            cost: villageInfo.cost // Include the cost in the result
          };
        });
  
        return new CommonResponse(true, 1, 'Data retrieved successfully', formattedResult);
      } else {
        return new CommonResponse(false, 0, 'No data found', []);
      }
  
    } catch (err) {
      throw err;
    }
  }
  
  
  
  


  async getAllContractors():Promise<CommonResponse>{
    try{
      const manager = getManager()
      const query = `select  c.contractor_name as contractor, c.contractor_id as contractorId
from erpx_dev_hrms.contractor c
`
const result = await manager.query(query)
if(result.length > 0){
  return new CommonResponse(true, 1,'Data retrieved successfully', result)
}else{
  return new CommonResponse(false, 0,'No data found',[])
}

    }catch(err){
      throw(err)
  }
  }

  async getBatchNumbersForStockTransfer(operation: OperationTypeEnum, plantId: number):Promise<CommonResponse>{
    try{

      const manager = getManager();
      const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'gi.plant_lot_number' : 'gi.lot_number'
      const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(query);
      var resQuery = `SELECT pi.lot_number as lotNumber FROM `+ appSettings.production_db+`.production_inventory pi LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.sales_db +`.sale_order_items soi ON soi.sale_order_item_id = pi.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = soi.varient_id LEFT JOIN `+appSettings.masters_db+`.products p ON p.product_id = sc.product_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on ${grnItemColumn}=pi.lot_number WHERE operation="${operation}" and status!="${FgStatusEnum.CLOSE}" AND (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) > 0`
      if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
        resQuery += " AND pi.sub_plant_id="+plantId;
      }else{
        resQuery += " AND pi.plant_id="+plantId+' and pi.sub_plant_id = 0';
      }
      resQuery += " GROUP BY pi.lot_number Order By (physical_quantity - issued_quantity - rejected_quantity - stock_transfer_qty - conversion_quantity) DESC, pi.lot_number DESC";
      const response =await manager.query(resQuery); 

    if(response.length > 0 ){

      return new ProductionInventoryResponse(true, 1111, 'Inventory Quantity Found Successfully', response)
    }else {
      throw new ErrorResponse(9999, 'No Data Found')
    }

    }catch(err){
      throw err
    }
  }



  async getWorkerWaseReport(req?: TransportChargesReq): Promise<CommonResponse> {
    console.log(req, "reqqqqqqqqqqqqqqqqqqqqqqqqq");
    try {
      const manager = getManager();
  
      let query = `
        select pw.emp_code as idNo, wo.worker_name as name, DATE_FORMAT(pl.date, '%d') as day, MONTHNAME(pl.date) as month, 
               ROUND(SUM(pw.avg_wage), 1) AS amount, pw.contractor_id, pl.date as date, pl.no_of_persons, 
               wo.village_from_id as villageId
        from erpx_dev_production.production_workers pw
        left join erpx_dev_masters.workers wo on wo.worker_code = pw.emp_code
        left join erpx_dev_production.production_log pl on pl.production_log_id = pw.production_log_id
      `;
  
      if (req?.contractorId) {
        query += ` AND pw.contractor_id = '${req.contractorId}'`;
      }
  
      if (req?.fromDate && req?.toDate) {
        query += ` AND pl.date BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
      if (req?.villageId) {
        query += ` AND wo.village_from_id = '${req.villageId}'`;
      }
  
      query += ` group by wo.worker_name, pl.date `;
  
      const result = await manager.query(query);
  
      if (result.length > 0) {
        const villageData = result.reduce((acc, row) => {
          const { idNo, name, day, month, amount } = row;
  
          // Initialize worker if not existing
          if (!acc[name]) {
            acc[name] = { idNo, months: {} };
          }
  
          // Initialize month if not existing for the worker
          if (!acc[name].months[month]) {
            acc[name].months[month] = { days: {} };
          }
  
          // Assign the amount for the day in the specific month
          acc[name].months[month].days[day] = amount;
  
          return acc;
        }, {});
  
        const formattedResult = Object.keys(villageData).reduce((acc, name) => {
          const { idNo, months } = villageData[name];
          const monthlyData = Object.keys(months).map(month => {
            const monthInfo = months[month];
            const currentYear = new Date().getFullYear();
            const monthIndex = new Date(`${month} 1, ${currentYear}`).getMonth();
            const daysInMonth = getDaysInMonth(new Date(currentYear, monthIndex));
  
            for (let day = 1; day <= daysInMonth; day++) {
              const dayStr = day < 10 ? `0${day}` : `${day}`;
              if (!monthInfo.days[dayStr]) {
                monthInfo.days[dayStr] = "0";
              }
            }
  
            return {
              idNo,
              name,
              monthinfo: month,
              days: monthInfo.days,
           // includ in the result
            };
          });
  
          return acc.concat(monthlyData);
        }, []);
  
        return new CommonResponse(true, 1, 'Data retrieved successfully', formattedResult);
      } else {
        return new CommonResponse(false, 0, 'No data found', []);
      }
    } catch (err) {
      throw err;
    }
  }
  
  async GetAllVillages():Promise<CommonResponse>{
    try {
      const manager = getManager();
      let query =`  select village_Name as villageName,village_transport_id as villageId
 from erpx_dev_masters.village_transport_cost
 group by village_name`
 const result = await manager.query(query)
if(result.length > 0){
  return new CommonResponse(true, 1,'Data retrieved successfully', result)
}else{
  return new CommonResponse(false, 0,'No data found',[])
}

  }catch(err){
  throw err;
  }

}
  async getOperationWiseCount():Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getQry = `SELECT COUNT(*) as count,operation FROM ${appSettings.production_db} .production_inventory p GROUP BY operation ORDER BY operation`
      const info = await manager.query(getQry)
      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async updateWagesInfoInWorkers():Promise<CommonResponse>{
    const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();
    try{
      await transManager.startTransaction()

      const qry = `SELECT pl.bill_no,SUM(pl.amount) as amount,pl.no_of_persons as persons,SUM(input_quantity) as inquantity,SUM(actual_output_quantity) as outquantity,peeling_price_based_on,pl.operation
      FROM production_log pl
      WHERE pl.no_of_persons > 0
      GROUP BY pl.bill_no`
      const info = await transManager.manager.query(qry)
      const flag = new Set<boolean>()
      for(const rec of info){
        const findBillInfoInWrorker = await transManager.manager.find(ProductionWorkersEntity,{where:{billNo:rec.bill_no}})
        if(findBillInfoInWrorker.length > 0){
          const avgQty = Number(rec.inquantity) / Number(rec.persons)
          const avgWage = Number(rec.amount) / Number(rec.persons)
          const updateInfo = await transManager.manager.update(ProductionWorkersEntity,{billNo:rec.bill_no},{avgQty:avgQty,avgWage:avgWage})
          if(updateInfo.affected){
            flag.add(true)
          }else{
            flag.add(false)
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating qty and wage')
          }
        }
      }
      if(!(flag.has(false))){
        await transManager.commitTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'success')
      }else{
        await transManager.rollbackTransaction()
        await transManager.release()
        return new CommonResponse(false,0,'Something went wrong in updating qty and wage')
      }

    }catch(err){
      await transManager.rollbackTransaction()
      await transManager.release()
      return new CommonResponse(false,0,'Something went wrong in updating qty and wage')
    }
  }

  async getProductsAgainstLotCount(req:LotAndOperationReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      // const getProductInfo = await this.inventoryRepository.find({where:{lotNumber:req.lotNumber,inputGrade:req.count,year:req.year,operation:req.operation,plantId:req.plantId},select:['product']})
      let productsInfoQry = `SELECT DISTINCT(product) as product FROM ${appSettings.production_db} .production_inventory WHERE prod_inv_id > 0`
      if(req.lotNumber != undefined){
        productsInfoQry += ` AND lot_number = '${req.lotNumber}' AND year = ${req.year}`
      }
      if(req.count !=  undefined){
        productsInfoQry += ` AND input_grade = '${req.count}'`
      }
      if(req.operation != undefined){
        productsInfoQry += ` AND operation = '${req.operation}'`
      }
      if(req.plantId != undefined){
        productsInfoQry += ` AND plant_id = ${req.plantId}`
      }
      if(req.product != undefined){
        productsInfoQry += ` AND product = '${req.product}'`
      }

      productsInfoQry += ` UNION ALL SELECT DISTINCT(product) as product FROM ${appSettings.production_db} .non_soaked_products WHERE non_soaked_product_id > 0`
      if(req.lotNumber != undefined){
        productsInfoQry += ` AND lot_code = '${req.lotNumber}' AND year = ${req.year}`
      }
      if(req.count !=  undefined){
        productsInfoQry += ` AND count = '${req.count}'`
      }
      if(req.plantId != undefined){
        productsInfoQry += ` AND plant_id = ${req.plantId}`
      }
      const getProductInfo = await manager.query(productsInfoQry)

      // const nonSoakedproducstInfo = await manager.query(nonSoakedProductsInfoQry)
      // const info = []
      if(getProductInfo.length >0){
        return new CommonResponse(true,1,'Data retrieved',getProductInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getRejectionFromProducts(req:LotAndOperationReq):Promise<CommonResponse>{
    try{
      const getProductsInfo = await this.logRepository.find({where:{lotNumber:req.lotNumber,year:req.year,operationType:OperationTypeEnum.VALUE_ADDITION,isRRP:true,plantId:req.plantId},select:['rejectionFrom']})
      if(getProductsInfo.length > 0){
        return new CommonResponse(true,1,'Data retrieved',getProductsInfo)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getSoakingOutProducts(req:LotAndOperationReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      const getSoakingOutproductsQry = `SELECT DISTINCT(product) as rejectionFrom FROM ${appSettings.production_db} .production_inventory WHERE lot_number = '${req.lotNumber}' AND year = ${req.year} AND operation = '${OperationTypeEnum.SOAKING}' AND plant_id = ${req.plantId}`
      const getSoakingOutProducts = await manager.query(getSoakingOutproductsQry)
      if(getSoakingOutProducts.length > 0){
        return new CommonResponse(true,1,'Data retrieved',getSoakingOutProducts)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

  async getNonSoakedProductsdata(req: JobReportingInfoReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
        let query = `
            SELECT nsp.non_soaked_product_id AS nonSoakedProductId,
                   nsp.lot_code AS lotCode,
                   nsp.operation AS operation,
                   nsp.count AS COUNT,
                   nsp.grade AS grade,
                   nsp.product AS product,
                   nsp.from_product AS fromProduct
            FROM ${appSettings.production_db}.non_soaked_products nsp
            WHERE 1=1`; 


        const parameters: any[] = [];
        
        if (req.lotNumber) {
            query += ` AND nsp.lot_code = ?`;
            parameters.push(req.lotNumber);
        }
        if (req.operation) {
            query += ` AND nsp.operation = ?`;
            parameters.push(req.operation);
        }
        if (req.product) {
            query += ` AND nsp.product = ?`;
            parameters.push(req.product);
        }

        const getNonSoakingProducts = await manager.query(query, parameters);
        
        if (getNonSoakingProducts.length > 0) {
            return new CommonResponse(true, 1, 'Data retrieved', getNonSoakingProducts);
        } else {
            return new CommonResponse(false, 0, 'No data found');
        }
    } catch (err) {

        return new CommonResponse(
            false,
            9999,
            'Failed to retrieve non-soaked products data',
            err instanceof Error ? err.message : String(err)
        );
    }
}

async getSoakingDataForSoakingReport(req?: ReportRequest): Promise<CommonResponse> {
  const manager = getManager();

  req.startDate = moment(req.startDate).format('YYYY-MM-DD');
  req.endDate = moment(req.endDate).format('YYYY-MM-DD');

  // let query = `
  //     SELECT
  //         pl.production_log_id AS production_log_id,
  //         IF(v.name != 'N/A'  , product,CONCAT(SUBSTRING(product, 1, LENGTH(product) - LOCATE('-', REVERSE(product))))) as product,
  //         SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
  //         SUM(IF(pl.operation = 'PACKING', pl.actual_output_quantity, 0)) AS actualOutputQuantity,
  //         AVG(sku.soaking_yield) as soakingYield
  //     FROM ${appSettings.production_db}.production_log pl
  //     LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.short_code = pl.product
  //     left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
  //     WHERE pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}','${ProductionProcessTypeEnum.REPROCESS}') and pl.operation IN ('SOAKING', 'PACKING') AND DATE(pl.date) BETWEEN '${req.startDate}' AND '${req.endDate}' AND process_type IN ('FRESHPRODUCITON','REPROCESS') AND  pl.rejection_from is null and pl.soakingout_product is null
  //     GROUP BY sku.food_type_id, sku.value_addition_one_id, sku.value_addition_two_id,
  //              sku.value_addition_three_id, sku.value_addition_four_id, sku.value_addition_five_id, sku.soaking_style
  //     HAVING inputQuantity > 0
  //     UNION ALL

  //     SELECT
  //         pl.production_log_id AS production_log_id,
  //         IF(v.name != 'N/A'  , rejection_from,CONCAT(SUBSTRING(rejection_from, 1, LENGTH(rejection_from) - LOCATE('-', REVERSE(rejection_from))))) as product,
  //         SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
  //         SUM(IF(pl.operation = 'PACKING', pl.actual_output_quantity, 0)) AS actualOutputQuantity,
  //         AVG(sku.soaking_yield) as soakingYield
  //     FROM ${appSettings.production_db}.production_log pl
  //     LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.short_code = pl.rejection_from
  //     left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
  //     WHERE pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}','${ProductionProcessTypeEnum.REPROCESS}') and pl.operation IN ('SOAKING','PACKING') AND DATE(pl.date) BETWEEN '${req.startDate}' AND '${req.endDate}' AND process_type IN ('FRESHPRODUCITON','REPROCESS') AND  pl.rejection_from is not null
  //     GROUP BY sku.food_type_id, sku.value_addition_one_id, sku.value_addition_two_id,
  //              sku.value_addition_three_id, sku.value_addition_four_id, sku.value_addition_five_id, sku.soaking_style
      
  //     UNION ALL

  //     SELECT
  //         pl.production_log_id AS production_log_id,
  //         IF(v.name != 'N/A'  , soakingout_product,CONCAT(SUBSTRING(soakingout_product, 1, LENGTH(soakingout_product) - LOCATE('-', REVERSE(soakingout_product))))) as product,
  //         SUM(IF(pl.operation = 'SOAKING', pl.input_quantity, 0)) AS inputQuantity,
  //         SUM(IF(pl.operation = 'PACKING', pl.actual_output_quantity, 0)) AS actualOutputQuantity,
  //         AVG(sku.soaking_yield) as soakingYield
  //     FROM ${appSettings.production_db}.production_log pl
  //     LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.short_code = pl.soakingout_product
  //     left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
  //     WHERE pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}','${ProductionProcessTypeEnum.REPROCESS}') and  pl.operation IN ('SOAKING','PACKING') AND DATE(pl.date) BETWEEN '${req.startDate}' AND '${req.endDate}' AND process_type IN ('FRESHPRODUCITON','REPROCESS') AND  pl.soakingout_product is not null
  //     GROUP BY sku.food_type_id, sku.value_addition_one_id, sku.value_addition_two_id,
  //              sku.value_addition_three_id, sku.value_addition_four_id, sku.value_addition_five_id, sku.soaking_style
  // `;

  // const data = await manager.query(query);

    let getSoakDataQry = `select pl.production_log_id AS production_log_id,IF(v.name != 'N/A' , product,CONCAT(SUBSTRING(product, 1, LENGTH(product) - LOCATE('-', REVERSE(product))))) as product,
          sum(input_quantity) as inputQuantity,AVG(sku.soaking_yield) as soakingYield
          from ${appSettings.production_db} .production_log pl 
          left join ${appSettings.masters_db} .sku_codes sku on sku.short_code = pl.product
          left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
          where pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}' , '${ProductionProcessTypeEnum.REPROCESS}') and operation  = '${OperationTypeEnum.SOAKING}' and pl.rejection_from is null and pl.soakingout_product is null`
          if (req.startDate !== undefined && req.endDate !== undefined) {
            getSoakDataQry += ` and (DATE(pl.date) between '${req.startDate}' and '${req.endDate}')`;
          }
          getSoakDataQry += ` group by sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.soaking_style
          HAVING inputQuantity > 0`
          const getSoakData = await manager.query(getSoakDataQry)
          // const soakDataMap = new Map<any,any>()
          // for(const rec of getSoakData){
          //   soakDataMap.set({date:rec.date,product:rec.product},rec)
          // }
  
          let getPackDataQry = `select pl.production_log_id AS production_log_id,IF(v.name != 'N/A' , product,CONCAT(SUBSTRING(product, 1, LENGTH(product) - LOCATE('-', REVERSE(product))))) as product,
          sum(actual_output_quantity) as actualOutputQuantity,AVG(sku.soaking_yield) as soakingYield
          from ${appSettings.production_db} .production_log pl 
          left join ${appSettings.masters_db} .sku_codes sku on sku.short_code = pl.product
                  left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
          where pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}' , '${ProductionProcessTypeEnum.REPROCESS}') and  operation  = '${OperationTypeEnum.PACKING}' and pl.rejection_from is null and pl.soakingout_product is null
           `
          if (req.startDate !== undefined && req.endDate !== undefined) {
            getPackDataQry += ` and DATE(pl.date) between '${req.startDate}' and '${req.endDate}'`;
          }
          getPackDataQry += ` group by sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.soaking_style
          HAVING actualOutputQuantity > 0 and product is not null`
  
          getPackDataQry += ` union all select pl.production_log_id AS production_log_id,IF(v.name != 'N/A' , rejection_from,CONCAT(SUBSTRING(rejection_from, 1, LENGTH(rejection_from) - LOCATE('-', REVERSE(rejection_from))))) as product,
          sum(actual_output_quantity) as actualOutputQuantity,AVG(sku.soaking_yield) as soakingYield
          from ${appSettings.production_db} .production_log pl 
          left join ${appSettings.masters_db} .sku_codes sku on sku.short_code = pl.rejection_from
                  left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
          where pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}' , '${ProductionProcessTypeEnum.REPROCESS}') and  operation  = '${OperationTypeEnum.PACKING}' 
          and rejection_from in (SELECT DISTINCT(product) from production_log where operation = '${OperationTypeEnum.SOAKING}' and DATE(date) BETWEEN '${req.startDate}' and '${req.endDate}')
          #AND pl.product NOT IN (SELECT DISTINCT(product) FROM production_log WHERE operation = 'SOAKING' AND DATE(DATE) BETWEEN '${req.startDate}' AND '${req.endDate}')
          `
          if (req.startDate !== undefined && req.endDate !== undefined) {
            getPackDataQry += ` and DATE(pl.date) between '${req.startDate}' and '${req.endDate}'`;
          }
          getPackDataQry += ` group by sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.soaking_style
          HAVING actualOutputQuantity > 0 and product is not null`
  
          getPackDataQry += ` union all select pl.production_log_id AS production_log_id,IF(v.name != 'N/A' , soakingout_product,CONCAT(SUBSTRING(soakingout_product, 1, LENGTH(soakingout_product) - LOCATE('-', REVERSE(soakingout_product))))) as product,        
          sum(actual_output_quantity) as actualOutputQuantity,AVG(sku.soaking_yield) as soakingYield
          from ${appSettings.production_db} .production_log pl 
          left join ${appSettings.masters_db} .sku_codes sku on sku.short_code = pl.soakingout_product
                  left join ${appSettings.masters_db} .value_addition_five_types v on v.value_addition_five_id = sku.value_addition_five_id
          where pl.process_type IN ('${ProductionProcessTypeEnum.FRESHPRODUCITON}' , '${ProductionProcessTypeEnum.REPROCESS}') and  operation  = '${OperationTypeEnum.PACKING}' 
          and soakingout_product in (SELECT DISTINCT(product) from production_log where operation = '${OperationTypeEnum.SOAKING}' and DATE(date) BETWEEN '${req.startDate}' and '${req.endDate}')
          #AND pl.product NOT IN (SELECT DISTINCT(product) FROM production_log WHERE operation = 'SOAKING' AND DATE(DATE) BETWEEN '${req.startDate}' AND '${req.endDate}')
          `
          if (req.startDate !== undefined && req.endDate !== undefined) {
            getPackDataQry += ` and DATE(pl.date) between '${req.startDate}' and '${req.endDate}'`;
          }
          getPackDataQry += ` group by sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.soaking_style
          HAVING actualOutputQuantity > 0 and product is not null`
          const getPackData = await manager.query(getPackDataQry)
          const packDataMap = new Map<any,any>()
          for(const rec of getPackData){
            if(!(packDataMap.has(JSON.stringify({product:rec.product})))){
              packDataMap.set(JSON.stringify({product:rec.product}),rec)
            }else{
             let prod =  packDataMap.get(JSON.stringify({product:rec.product})).actualOutputQuantity 
             packDataMap.get(JSON.stringify({product:rec.product})).actualOutputQuantity = (Number(Number(prod) + Number(rec.actualOutputQuantity))).toFixed(2)
            }
          }

           const productWiseData = [];
            getSoakData.forEach(row => {
              row.actualOutputQuantity = packDataMap.get(JSON.stringify({product:row.product})) != undefined ? Number((packDataMap.get(JSON.stringify({product:row.product})).actualOutputQuantity)/1000).toFixed(3) : 0
              row.inputQuantity = row.inputQuantity > 0 ? Number((row.inputQuantity)/1000).toFixed(3) : 0
              row.yieldPercent = (((row.actualOutputQuantity  /  row.inputQuantity )* 100)).toFixed(2)
              productWiseData.push(row)
                // const { product, inputQuantity, actualOutputQuantity,soakingYield } = row;
                // Replace '-16/20' or '-1' using regex
                // const modifiedProduct = product
                // if (!productWiseData[modifiedProduct]) {
                //     productWiseData[modifiedProduct] = [];
                // // }
                // productWiseData.push({ 
                //   product:
                //   soakingYield,
                //   inputQuantity, 
                //   actualOutputQuantity,
                //   yieldPercent: (((actualOutputQuantity / inputQuantity )* 100)).toFixed(2)
                //   });
            });
          //   const result = Object.keys(productWiseData).map(modifiedProduct => ({
          //     product: modifiedProduct,
          //     data: productWiseData[modifiedProduct]
          // }));

 

  // const fractionPattern = /-\d+\/\d+$/;

  // const modifiedData = data.map(item => {
  //     // const product = item.product;

  //     // if (typeof product === 'string' && fractionPattern.test(product)) {
  //     //     item.product = product.replace(fractionPattern, '');
  //     // }
  //       const inputQty = parseFloat(item.inputQuantity);
  //       const outputQty = parseFloat(item.actualOutputQuantity);
    
  //       item.yieldPercent = inputQty > 0 ? parseFloat(((outputQty / inputQty) * 100).toFixed(2)) : 0;
  
  //       return item;
  // });

  if (productWiseData && productWiseData.length > 0) {
      return new CommonResponse(true, 1, "Soaking Details Retrieved Successfully", productWiseData);
  } else {
      return new CommonResponse(false, 0, "No Data Found", []);
  }
}




}





